import { EnumBenefitInsurancePlanState } from "constants/enums/benefit-insurance-plan-state";
import { NameChangeRequestStatus } from "constants/enums/name-change-request-status";
import { NotificationTemplateType } from "constants/enums/notification-template-type";
import { EnumOrderStatus } from "constants/enums/order-status";
import { PaymentCategoryEnum } from "constants/enums/payment-category";
import { EnumPaymentMethod } from "constants/enums/payment-method";
import { EnumPaymentScheduleMethod } from "constants/enums/payment-schedule-method";
import { EnumPaymentStatus } from "constants/enums/payment-status";
import { PaymentTransactionStatusEnum } from "constants/enums/payment-transaction-status";
import { EnumRelationship } from "constants/enums/relationship";

const en = {
  translation: {
    common: {
      error: "Error",
    },
    client: {
      enhancers: {
        withPreventLeaveDirtyForm: {
          cancelEdit: "Confirm leaving this page",
          cancelConfirm:
            "Your changes will not be saved. Do you want to leave?",
          close: "Go back to editing",
          canceledEdit: "Leave without saving",
        },
      },
      benefitInsurancePlanState: {
        draft: "Draft",
        [EnumBenefitInsurancePlanState.ACTIVE]: "Active",
        [EnumBenefitInsurancePlanState.PENDING_REVIEW]: "Pending review",
        [EnumBenefitInsurancePlanState.REJECTED]: "Rejected",
        [EnumBenefitInsurancePlanState.CANCELING_REVIEW]: "Canceling review",
        [EnumBenefitInsurancePlanState.REFUNDED]: "Refunded",
        [EnumBenefitInsurancePlanState.INACTIVE]: "Inactive",
        [EnumBenefitInsurancePlanState.PENDING_RENEWAL]: "Pending renewal",
        [EnumBenefitInsurancePlanState.WAITING]: "Waiting",
        [EnumBenefitInsurancePlanState.CANCELED]: "Canceled",
        [EnumBenefitInsurancePlanState.OVER_DUE]: "Over due",
        // [EnumBenefitInsurancePlanState.FAILED]: "Failed",
      },
      api: {
        modal401Title: "Login expired",
        modal401Children: "Login expired Please log in again.",
        modal401OkButtonLabel: "Login",
        modal403Title: "Error",
        modal403Children:
          "Your user role doesn't have access to this section. Please log in again.",
        modal403OkButtonLabel: "Login",
        modal500Title: "Error",
        modal500OkButtonLabel: "Ok",
      },
      pages: {
        main: {
          admins: {
            index: {
              title: "Add/Remove Admin",
              home: "Home",
              addButton: "Add admin",
              admins: "Add/Remove Admin",
              deleteButton: "Delete admin",
              columns: {
                fullName: "Full name",
                email: "Email",
                status: "Status",
                code: "Code",
                lastActiveAt: "Last active at",
                createdAt: "Created at",
                updatedAt: "Updated at",
                role: "Role",
                values: {
                  availableStatus: {
                    active: "active",
                    inactive: "inactive",
                  },
                },
              },
            },
            new: {
              home: "home",
              rootPath: "Admin",
              title: "Add admin",
              header: "Input admin email",
              link: "URL link would be sent to this email",
              send: "Send",
              cancel: "Cancel",
              email: "Email",
              role: "Role",
              notificationSuccess: "successful transaction",
            },
            edit: {
              title: "General Data",
              home: "Home",
              status: "Status",
              rootPath: "Admin",
              cancel: "Cancel",
              save: "Save",
              cantEditYourself:
                "Editing status and roles cannot be done by yourself, only an Admin who has permission to edit permission of Admin can do so, such as Super Admin.",
              firstName: "First Name",
              lastName: "Last Name",
              role: "Role",
              email: "Email",
              available: "Available",
            },
          },
          frontStoreManagement: {
            index: {
              title: "Manage Front store",
              home: "Home",
              addButton: "Create Front store",
              DYNAMIC_CONFIG: "Theme Management",
              PACKAGE_DISPLAY: "Insurance Package Settings",
              FATCA_QUESTIONS: "FATCA Questions",
              FRONT_STORE_APPEARANCE: "Front store details",
              tabsTitle: "Details",
              filters: {
                title: "Front store",
                name: "Front store name",
                type: "Type",
                typeAll: "All",
                typeFreelance: "freelance",
                typeEnterprise: "enterprise",
                reset: "Reset",
                filter: "Filter",
              },
              columns: {
                name: "Front store name",
                type: "Type",
                description: "Notes",
                updatedAt: "Last modified",
              },
              deleteFrontStore: "Delete Front Store",
              frontStoreInfo: "Front Store",
              cannotBeRestored: "data will be deleted and cannot be recovered",
              close: "Close",
              delete: "Delete data",
              notificationSuccess: "successful transaction",
            },
            createModal: {
              title: "Create Front store",
              name: "Front store name",
              type: "Type",
              typePlaceholder: "Select type",
              typeFreelance: "freelance",
              typeEnterprise: "enterprise",
              cancel: "Cancel",
              confirm: "Confirm",
              success: "Action successful",
              errorTitle: "Error",
              errorMessage: "Unable to create Front store",
              errorClose: "Close",
            },
            details: {
              title: "Details",
              name: "Front store name",
              type: "Type",
              description: "Notes",
              cancel: "Cancel",
              save: "Save",
              success: "Saved successfully",
              typeFreelance: "freelance",
              typeEnterprise: "enterprise",
            },
            packageDisplay: {
              title: "Package Setting",
              cantEditYourself:
                "Select insurance packages to display in “Promotion Packages” and “Recommended Packages” on the Web Application at this step.",
              enrollmentId: "Enrollment Round",
              enrollmentIdHelperText:
                "Select the enrollment round associated with the Application to manage desired packages.",
              changeEnrollmentConfirmTitle: "Confirm Enrollment Change",
              changeEnrollmentConfirmMessage:
                "Changing the enrollment round will remove all selected promotion and recommended packages. Do you want to continue?",
              changeEnrollmentConfirmCancel: "Cancel",
              changeEnrollmentConfirmOk: "Confirm",
              option1: "Option 1",
              promotionPackages: "Promotion Packages",
              promotionPackagesDescription:
                'Select insurance packages to display in "Promotion Packages" of the Web Application (display order will be from top to bottom)',
              recommendPackagesDescription:
                'Select insurance packages to display in "Recommended Packages" of the Web Application \n (display order will be from top to bottom)',
              recommendPackages: "Recommended Packages",
              add: "Add",
              image: "Image",
              description: "Description",
              actions: "Manage",
              name: "Name",
              save: "Save",
              deleteModalTitle: "Delete Package",
              deleteModalContent:
                "Package data <b>{{name}}</b> will be deleted and cannot be restored",
              close: "Close Window",
              delete: "Delete",
              components: {
                editPromotionPackageModal: {
                  save: "Save",
                  cancel: "Cancel",
                  image: "Image",
                  imageHelperText:
                    "Image .jpg, .svg max file size 1 MB (Recommended 190 x 143 pixel)",
                  description: "Description",
                  packageHeader: "Edit {{name}}",
                },
              },
              success: "Success",
            },
            fatcaQuestions: {
              fatcaDetails: "FATCA Details",
              fatcaDetailsDescription: "Text for preferred",
              fatcaDetailsPlaceholder: "Enter FATCA details",
              questionList: "Question List",
              questionListDescription: "Manage FATCA question list",
              question: "Question",
              lastModifiedDate: "Last modified date",
              noQuestionsFound: "No questions found",
              save: "Save",
              saveSuccess: "Saved successfully",
              addQuestionButton: "Add question",
              deleteModalTitle: "Delete Question",
              deleteModalContent:
                "Are you sure you want to delete this question?",
              cancel: "Cancel",
              confirmDelete: "Confirm Delete",
              deleteSuccess: "Question deleted successfully",
              addQuestion: {
                title: "Add Question",
                home: "Home",
                frontStoreManagement: "Manage Front store",
                frontStoreDetail: "Details",
                questionInfo: "Question Information",
                question: "Question",
                choices: "Choices",
                choicesInstruction1:
                  "Please select the Checkbox in front of the choice that is the answer to the question",
                choicesInstruction2:
                  "The system will verify and prevent those who answer incorrectly from proceeding to the next step of purchasing insurance",
                autoCorrectChoice: "Auto-correct choice",
                answerRequiredWhenAutoCorrect:
                  "Please select the choice that is the correct answer",
                choiceLabel: "Choice",
                addChoice: "Add choice",
                cancel: "Cancel",
                addQuestion: "Add Question",
                editTitle: "Edit Question",
                save: "Save",
                saveSuccess: "Question added successfully",
                editSuccess: "Question updated successfully",
              },
            },
          },
          authentication: {
            LoginPage: {
              or: "or",
              title: "My Benefit",
              title1: "Fill email and receive OTP for sign-in",
              title2: "Fill email and receive OTP for sign-up",
              emailField: "Email",
              getOtp: "Request OTP",
              invalidEmail: "Email is incorrect",
              signInWithAzureAd: "Sign in with Azure AD",
              logoutAzureAd: "Sign out Azure AD",
            },
            VerifyOtp: {
              title: "Fill OTP for sign-in",
              otpInfo:
                "Fill OTP from {{currentEmail}} (OTP expire in {{otpExpireInMin}} minutes)",
              otp: "OTP",
              refCode: "ref:{{refCode}}",
              notReceiveOtp: "Didn't get OTP?",
              retryOtp: "Resend OTP again",
              canRetryIn: "you can retry in {{timeLeft}} seconds",
              login: "Login",
              changeEmail: "Change Email",
              home: "Return to home page",
              otpMustNumber: "OTP must be a number",
              ok: "OK",
            },
          },
          enrollment: {
            index: {
              title: "Enable/Disable Insurance & Package",
              status: "Status",
              year: "Year",
              reset: "Reset",
              filter: "Filter",
              home: "Home",
              startDate: "Start date",
              endDate: "End date",
              amount: "Attendee",
              state: {
                name: "Status",
                all: "All",
                draft: "Draft",
                published: "published",
                publishing: "publishing",
                pending: "Pending",
                active: "Active",
                closed: "Close",
              },
              updatedAt: "Updated at",
              cycleName: "Cycle Name",
              createEnrollment: "Create Enrollment",
              deleteTitle: "Delete",
              deleteModalInfo1: "The",
              enrollment: "enrollment at {{year}}",
              deleteModalInfo2: "will be deleted and cannot be restored.",
              closeDeleteModal: "close",
            },
            CreateEnrollmentModal: {
              title: "Create Enrollment",
              description: "Please specify the year of use.",
              year: "year",
              cancel: "cancel",
              error: {
                title: "Something went wrong!",
                close: "close",
              },
            },
            detail: {
              title: "Enrollment {{year}}",
              step: "Step ({{step}}/{{of}})",
              draft: "draft",
              pending: "pending",
              published: "published",
              publishing: "publishing",
              active: "active",
              closed: "closed",
              home: "Home",
              enrollment: "Enrollment",
              state: {
                1: "Period Settings",
                2: "Attendee Validating",
                3: "Insurance Management",
                4: "Insurance Package Management",
                5: "Data Settings",
                6: "Validating & Publish",
              },
              pendingText:
                "If the insurance information is found to be incorrect Please press notify the insurance policy amendment and contact Zennite to correct the insurance policy before proceeding.",
              pendingButton: "Edit Insurance",
              cancel: "Cancel",
              pendingModalText1:
                "This Enrollment can be locked out until the insurance information is corrected by Zennite.",
              pendingModalText2:
                "* After pressing notification of editing Please provide details of corrections through Zennite's contact methods.",
              generateLinkDescription:
                "Once the registration is published, the insurance plan or package link can be shared on other platforms.",
              generateLinkButton: "View details Link",
              generateLinkModal: {
                title: "List of insurance policies in round “{{name}}”",
                name: "Insurance plan/package name",
                companyName: "Company name",
                type: "Type",
                insuranceName: "Insurance name",
                shortDescription: "Short Description",
                filter: "Filter",
                reset: "Reset",
                all: "All",
                package: "Package",
                copySuccess: "Copy the link to the clipboard.",
                copyFailed: "Copying the link to the clipboard failed.",
              },
              editShortDescriptionModal: {
                title: "Edit insurance information.",
                name: "Insurance name",
                company: "Company",
                type: "Type",
                shortDescription:
                  "Short description (for insurance policies purchased via a link from an external website)",
                cancel: "Cancel",
                save: "Save",
              },
            },
            PeriodSetting: {
              enrollmentPeriodSetting: "Period Setting",
              updatedAt: "updated at: {{updatedAt}}",
              cycleName: "Cycle Name",
              startDate: "Start date to choose insurance",
              endDate: "End date to choose insurance",
              startDateLessThanEndDate: "startDate must be less than endDate",
              existingAttendeeSelectionPeriodInDays:
                "Period of existing attendee to choose",
              incomingAttendeeSelectionPeriodInDays:
                "Period of incoming attendee to choose",
              existingAttendeeSelectionPeriodInDaysInfo:
                "From the start date, choose insurance.",
              incomingAttendeeSelectionPeriodInDaysInfo:
                "From the date of becoming an employee",
              saveAndNext: "Save & Next",
              save: "Save",
              saveSuccess: "Successful",
              masterInsurance: "Master Insurance",
              noti:
                "Once saved, the information displayed in the app will be updated immediately.",
              alertNoLimit: {
                desc1:
                  "In Freelance mode, it is recommended to select <b>Unlimited Insurance Period</b> to allow users to purchase insurance at any time without a specified end date.",
              },
              isNoLimit: "There is no time limit for choosing insurance.",
            },
            enrollmentAttendee: {
              alertSyncData: {
                desc1:
                  "The <b>“Update Data”</b> button is for Enterprise mode only.",
                desc2:
                  "If in Freelance mode, syncing data will fail because it is not configured, <b>but it does not affect usage</b>.",
              },
              title: "Checked Attendees",
              field: "Employee code / Firstname-Lastname",
              reset: "Reset",
              filter: "Filter",
              next: "Next",
              lastUpdate: "Last update: {{updatedAt}}",
              updateData: "Update Data",
              code: "Code",
              name: "Name",
              department: "Department",
              position: "Position",
              filterNotFound:
                "No search results were found. Please check the values in the filter again.",
              syncModal:
                "The system is updating information. Please do not close this screen until the update is complete.",
              noAttendee: "No Attendee",
              syncSuccess: "Sync Success",
              syncFail: "Sync Fail",
              infoText:
                "Your workspace allows users to choose their own detailed insurance plans, so there's no need to manage plans at this stage (you can just click Next).",
            },
            enrollmentInsurancePackage: {
              title: "Packages",
              name: "Package name",
              coverageLevel: "Coverage Level",
              insuranceName: "{{insuranceName}}",
              remark: "Remark",
              next: "Next",
              lastUpdate: "Last update: {{updatedAt}}",
              insuranceFor: {
                employee: "Employee insurance package information",
                family: "Family insurance package information",
              },
              infoText:
                "Your workspace allows users to choose their own detailed insurance plans, so there's no need to manage plans at this stage (you can just click Next).",
            },
            attendeeGrouping: {
              file: "file",
              detail: "Insurance details for the App",
              deletetitle: "Delete",
              deletetitle1:
                "Insurance details data displayed in the App will be deleted and cannot be recovered.",
              cancel: "close",
              title: "Grouping",
              info:
                "Points entered in this field include the initial insurance value.",
              currentScore: "CurrentScore",
              unit: "points",
              type: "Type",
              saveAndNext: "Save And Next",
              save: "Save",
              ok: "ok",
              titleError: "Unable to save data",
              errorDetail1:
                "The total value of the default insurances cannot exceed the initial points.",
              errorDetail2:
                "Please edit the “Available points” or re-select the default insurances for the following employee groups.",
              saveSuccess: "Successful",
              custom: "Choose by yourself",
              package: "Choose from insurance packages",
              none: "Not open to choose",
              packageHeader: "Selectable insurance packages",
              noti:
                "Once saved, the information displayed in the app will be updated immediately.",
              saveConfirmTitle: "Do you want to save the data?",
              saveConfirmDescription:
                "Once saved, the information displayed in the app will be updated immediately. Please verify the accuracy of the information before proceeding.",
              cancelConfirmModal: "Cancel",
              InsuranceList: {
                add: "Select Insurance",
                deleteInsuranceModalTitle: "Delete Insurance",
                deleteInsuranceModalInfo1: "Insurance data",
                deletePackageModalTitle: "Delete Package",
                deletePackageModalInfo1: "Package data",
                deleteModalInfo2: "will be deleted and cannot be restored.",
                close: "Close Window",
                confirmDelete: "Delete",
                insuranceName: "Insurance name",
                packageName: "Package name",
                remark: "Remark",
                deleteSuccess: "Delete success",
                modalInsuranceTitle:
                  "Select insurance type {{type}} for {{group}}.",
                modalPackageTitle: "Select package to attendee",
                modalCancel: "Cancel",
                modalConfirm: "Select",
                delete: "Delete",
                insuranceTypeHeader: "{{type}} insurance",
                packageHeader: "Select a package for {{group}}.",
                default: "Default",
                isActive: "Is active",
                companyName: "Company name",
              },
              InsuranceSelectorModal: {
                insuranceName: "Insurance name",
                packageName: "Package name",
                remark: "Remark",
              },
            },
            validate_and_published: {
              index: {
                previewAlert: {
                  desc1:
                    "The <b>Preview</b> button is for Enterprise mode only.",
                  desc2:
                    "If in Freelance mode, you can preview at the Front store menu instead.",
                },
                title: "Validating & Publishing",
                period: "Period",
                edit: "Edit",
                warningMessage:
                  "Once published, this round of registration information will no longer be able to be modified (other than by extending the validity period). Please check all information before publishing registration.",
                cycleName: "Cycle Name",
                year: "Year",
                startDate: "Start date",
                endDate: "End date",
                existingEnrollmentDaysLeft:
                  "Existing Employee Enrollment DayLeft",
                incomingEnrollmentDaysLeft:
                  "Incoming Employee Enrollment DayLeft",
                days: "Days",
                insuranceDetail: "Insurance Details",
                insuranceDetails: "Insurance Details",
                score: "Score",
                type: "Type",
                published: "published",
                publishing: "publishing",
                preview: "Preview",
                employees: "Employees",
                code: "Code",
                name: "Name",
                department: "Department",
                position: "Position",
                insuranceName: "Insurance name",
                remark: "Remark",
                default: "Default",
                employeeDetail: "Employees Detail",
                customTitle: "Optional {{nameTitle}} insurance",
                packageTitle: "Package {{nameTitle}}",
                publishEnrollment: "Published Enrollment",
                cancel: "Cancel",
                publishModalText:
                  "Once published, it will not be possible to edit the registration information for this round again.",
                publishModalText2:
                  "Please verify all information before publishing the registration.",
                errorTitle: "Error",
                submit: "Submit",
                errorModalText:
                  "This Enrollment insurance dataset has been modified.",
                errorModalText2:
                  "Please wait until the modification of the insurance package is complete. Then do the list again.",
                success: "Successfully",
                errorValidateText:
                  "Cannot be published Because the details of the employee group {{title}} are not complete.",
                custom: "Choose by yourself",
                package: "Choose from insurance packages",
                none: "Not open to choose",
                syncEmployeeErrorOnPublishedTitle: "Cannot Published",
                syncEmployeeErrorOnPublished:
                  "Unable to retrieve latest employee information. making it impossible to publish Please check the employee information file. or contact the system administrator",
                publishingModal:
                  "The system is publishing enrollment. Please do not close this screen until the update is complete.",
                masterInsurance: "Master Insurance",
                nonDefaultTitle:
                  "There are insurance plans that have not yet been selected as the initial insurance as follows",
                nonDefaultDescription:
                  "Do you want to publish without choosing the default insurance type?",
              },
            },
            InsurancePlanValidating: {
              title: "Insurance Management",
              name: "Insurance name",
              remark: "Remark",
              next: "Next",
              updatedAt: "Latest Update : {{date}}",
              coverageLevel: "Level",
              insuranceFor: {
                employee: "Employee insurance information",
                family: "Family insurance information",
              },
            },
            enrollmentInsurance: {
              home: "Home",
              enrollment: "Enrollment",
              name: "Insurance name",
              insuranceType: "Insurance type",
              protectionStartDate: "Protection start date",
              protectionEndDate: "Protection end date",
              premium: "Permium (Baht)",
              remark: "Remark",
              description: "Description",
              back: "Back",
              isFamily: "Insurance for",
              coverageLevel: "Coverage Level",
              insuranceFor: {
                employee: "Employee",
                family: "Family",
              },
              previewMyPolicy: "View a sample of my policy's front page",
              previewInsuranceDetail:
                "View a sample of the insurance details page",
            },
          },
          insurance: {
            detail: {
              title: "Insurance {{year}}",
              step: "Step ({{step}}/{{of}})",
              draft: "draft",
              published: "published",
              publishing: "publishing",
              editing: "active",
              insuranceDetailTitle: "Insurance Management",
              packageTitle: "Package Management",
              validateAndPublish: "Validating & Publish",
              breadcrumbs: {
                home: "Home",
                insurance: "Insurance Management",
              },
              manageWeightTitle: "Manage Weight Value",
            },
            SelectMasterInsurancePlansModal: {
              modalTitle: "Select Insurance Plan{{type}}",
              name: "Insurance Plan Name",
              company: "Insurance Company",
              remark: "Remark",
              save: "Select",
              close: "Cancel",
              riderHelp: 'Is Rider of Insurance{{type}} "{{planName}}"',
            },
            InsuranceDetail: {
              insuranceType: "{{name}}",
              notice:
                "It is recommended to select no more than 6 items per type for optimal display on the Front Store.",
              companyName: "Company Name",
              masterInsuranceName: "Master Insurance Plan Name",
              duration: "Duration",
              protectionStartDate: "Start Protection",
              protectionEndDate: "End Protection",
              insuranceData: "Insurance",
              saveAndNext: "Save & Next",
              save: "Save",
              saveSuccess: "Successful",
              add: "Add Insurance",
              insuranceFor: {
                employee: "Employee insurance information",
                family: "Family insurance information",
              },
              selectHowToFillInsuranceDetail:
                "Choose how to fill out insurance details",
              selectForFreelance: "The new form is for freelance clients",
              selectForFreelanceTitle: "Detailed field breakdown",
              selectForEnterprise: "The old form is for enterprise clients",
              selectForEnterpriseTitle: "Single-Column Markdown",
              cancel: "cancel",
              ok: "ok",
              saveUnsuccess: "Data saving failed",
              invalidDependentContent:
                "Because there is no primary insurance coverage for the following insurance policies",
              accept: "OK",
              rider: "Additional contract",
              dependent:
                "At least one additional primary insurance policy must be added",
            },
            InsuranceList: {
              add: "Add Insurance",
              deleteModalTitle: "Delete Insurance",
              deleteModalInfo1: "Insurance data",
              deleteModalInfo2: "will be deleted and cannot be restored.",
              close: "close",
              confirmDelete: "delete",
              name: "Insurance Name",
              premium: "Full Premium",
              remark: "Remark",
              deleteSuccess: "Successfully",
              cannotDeleteWhenUsedInPackage:
                "Can't be deleted because it's used in Packages.",
              cannotDeleteWhenHasBeenGroup:
                "Cannot be deleted because it was used to organize data in the annual registration {{year}}",
              saveYourPackagesFirst: "Please save your package first",
              coverageLevel: "Coverage Level",
              duplicateModalTitle: "Copy Insurance Plan",
              duplicateModalContent: "Do you want to copy the insurance plan?",
            },
            InsuranceForm: {
              name: "Insurance Name",
              info: "Insurance Detail",
              nameTh: "Insurance Name (TH)",
              nameEn: "Insurance Name (EN)",
              premium: "Premium (Baht)",
              remark: "Remark",
              remarkTh: "Remark (TH)",
              remarkEn: "Remark (EN)",
              save: "Save",
              cancel: "Cancel",
              back: "Back",
              breadcrumbs: {
                home: "Home",
                insurance: "Insurance Management",
                insuranceDetail: "Insurance At {{year}}",
                ipdTitle: "IPD Insurance",
                opdTitle: "OPD Insurance",
                dentalTitle: "Dental Insurance",
              },
              success: "Successfully",
              coverageLevel: "Coverage Level",
              coverageLevelHelper:
                "*To meet the objectives of employee benefits, if family insurance is selected, the system will filter only family insurance plans at a level lower than or equal to the coverage level selected for the employee",
              insuranceFor: "Insurance for",
              insuranceType: "Insurance type",
              insuranceForOptions: {
                employee: "Employee",
                family: "Family",
              },
              addInsurance: "Add Insurance",
            },
            InsurancePackage: {
              back: "Back",
              add: "Add Insurance Package",
              allPoint: "allPoint",
              deleteModalTitle: "Delete Package",
              deleteModalInfo1: "Package data",
              deleteModalInfo2: "will be deleted and cannot be restored.",
              close: "Close",
              confirmDelete: "Delete",
              save: "Save",
              cancel: "Cancel",
              breadcrumbs: {
                home: "Home",
                insurance: "Insurance Management",
                insuranceDetail: "Insurance At {{year}}",
              },
              success: "Successfully",
              newPackageHeader: "Package detail",
              packageNameTh: "Package name (TH)",
              packageNameEn: "Package name (EN)",
              remarkTh: "Remark (TH)",
              remarkEn: "Remark (EN)",
              packageName: "Package name",
              insuranceName: "Insurance Package Name",
              insuranceNameTh: "Insurance Package Name (TH)",
              insuranceNameEn: "Insurance Package Name (EN)",
              insuranceType: "Type",
              startDate: "Protection Start Date",
              endDate: "Protection End Date",
              premium: "Premium (Baht)",
              description: "Description",
              saveAndNext: "Save & Next",
              saveSuccess: "Successful",

              title: "Package management",
              infoText0:
                "If used with the Web Application, please organize promotional packages and popular benefit packages at this step.",
              infoText:
                "If the client company allows employees to choose the same insurance, flex can skip this step.",
              tableHeader: "Package insurance",
              name: "Package name",
              remark: "Remark",
              packagePricingType: "Package Pricing Type",
              pricingType: {
                SUM_INSURANCES: "Sum of all package prices",
                ALL_REMAINING: "All remaining",
                SET_OWN_PRICE: "Set own price",
              },
              SUM_INSURANCES: "Sum of all package prices",
              ALL_REMAINING: "All remaining",
              SET_OWN_PRICE: "Set own price",
              insuranceForOptions: {
                employee: "Employee",
                family: "Family",
              },
              insuranceFor: "Insurance for",
              priceType: "Package price",
              coverageLevel: "Coverage Level",
              coverageLevelHelper:
                "*To meet the objectives of employee benefits, if family insurance is selected, the system will filter only family insurance plans at a level lower than or equal to the coverage level selected for the employee",
              packageFor: {
                employee: "Employee package information",
                family: "Family package information",
              },
              level: "Level",
              duplicateModalTitle: "Copy Package",
              duplicateModalContent: "Do you want to copy the package?",
              requiredPackage:
                "The package must contain at least one type of insurance information",
              cannotDeleteWhenHasBeenGroup:
                "Cannot be deleted because it was used to organize data in the annual registration {{year}}",
              invalidDependentHelp: "There is no main insurance in the package",
              noMainInsurance: "No primary insurance",
            },
            insurancePackages: {
              ViewInsurance: {
                name: "Name",
                type: "Type",
                startDate: "StartDate",
                endDate: "EndDate",
                premium: "Premium (Baht)",
                remark: "Remark",
                description: "Description",
              },
            },
            InsurancePreview: {
              warning:
                "After publishing, if there is an amendment that will affect the work of HR, please check the information completely before publishing",
              title: "Validating & Publish",
              subtitle1: "Period",
              subtitle2: "Insurance",
              sortByType: "Sort by type",
              startDate: "Start Date",
              endDate: "End Date",
              tab1: "Sort by type",
              tab2: "Sort by package",
              notFoundPackage: "Not found package",
              notFoundData: "Data Not found.",
              edit: "Edit",
              cancel: "Cancel",
              publish: "Publish",
              rePublish: "Republish",
              modalTitle: "Publish insurance",
              insuranceName: "Insurance name",
              insuranceRemark: "Remark",
              packagePricingType: "Package Pricing Type",
              SUM_INSURANCES: "Sum of all package prices",
              ALL_REMAINING: "All remaining",
              rePublishModalTitleWarning: "Republish insurance",
              rePublishModalWarning:
                "Publication of this insurance This will result in the loss of all insurances grouped by HR and need to be regrouped.",
              success: "Successfully",
              insuranceTableHeader: "Optional {{name}} insurance",
              insuranceFor: {
                employee: "Employee Insurance Set Information",
                family: "Family insurance set information",
              },
              pricingType: "Full premium",
              level: "Level",
              pricingTypeText: {
                SUM_INSURANCES: "Sum of all package prices",
                ALL_REMAINING: "All remaining",
                SET_OWN_PRICE: "Set own price",
              },
              noRowInsurance:
                "No insurance plan information found for {{name}}",
              noRowInsurancePackage: "No package information found",
              insuranceType: {
                IPD: "IPD",
                OPD: "OPD",
                DENTAL: "Dental",
                ACCIDENT: "Accident",
                HEALTH: "Health",
                ANNUITY: "Annuity",
              },
              detail: {
                insuranceName: "Insurance Plan Name",
                insuranceCompany: "Insurance Company Name",
                insuranceType: "Type",
                remark: "Remark",
                back: "Back",
                previewMyPolicy: "View a sample of my policy's front page",
                previewInsuranceDetail:
                  "View a sample of the insurance details page",
                breadcrumbs: {
                  home: "Home",
                  insurance: "Insurance Management",
                  insuranceDetail: "Insurance At {{year}}",
                },
              },
            },
            FreelanceInsuranceForm: {
              breadcrumbs: {
                home: "Home",
                insurance: "Insurance Management",
                insuranceDetail: "Insurance {{year}}",
              },
              tab1: "Insurance Plan Details",
              tab2: "Information for a Custom Package",
              tab3: "Policy Table",
              detail: {
                info: "Insurance Plan Details",
                companyName: "Insurance Company",
                insuranceName: "Insurance Plan Name",
                remark: "Remark",
                active: "Active",
                addItem: "Add Item",
                order: "Order",
                orderName: "Item Name",
                detail: "Details",
                summaryTable: "Summary Table",
                listOfBenefits: "List of Benefits",
                compensationList: "List of Compensations",
                insurancePlanDetail: "Insurance Plan Details",
                summaryBenefit: "Benefit Summary",
                policyAndConditions: "Policy Terms and Conditions",
                termsAndBenefits: "Terms and Benefits",
                documentRequirementsAndBenefits:
                  "Document Requirements and Benefits",
                policyInformation:
                  "Policy Information (for display in My Policies)",
                acceptPdf: "Only Accept .pdf",
                browseFile: "Browse File",
              },
              infoCustomPackage: {
                info: "Values used to select a type of insurance",
                accident: {
                  byAccident: "Death from an accident",
                  insuranceMoney: "Sum assured",
                },
                health: {
                  ipd: "Inpatient medical expenses (IPD)",
                  opd: "OPD Plus+ (OPD+)",
                },
                annuity: {
                  ipd: "Inpatient medical expenses (IPD)",
                },
                amount: "Amount",
                detail: "Details",
              },
              compensationTable: {
                info: "Insurance premium",
              },
              cancel: "Cancel",
              save: "Save",
            },
            ManageWeightForm: {
              title: "Manage Weight Value",
              insuranceType: "{{name}}",
              alert:
                "Weight value is used to calculate insurance plan search results on the Web application. Set a weight value in the range of 1-5 for each insurance plan. The higher the weight value, the more likely the plan will appear in search results.",
              table: {
                template: "Insurance Plan",
                name: "Plan Name",
                value: "Weight Value",
              },
              saveAndNext: "Save & Next",
              save: "Save",
              saveSuccess: "Save Success",
            },
          },
          roles: {
            index: {
              title: "Set Permissions",
              columnTitle: "Role",
              home: "Home",
              addButton: "Add role",
              list: "Set Permissions",
              deleteRole: "Role data will be deleted and cannot be restored",
              deletedRole: "Delete",
              description: "Description",
              amount: "Amount of users",
              updatedAt: "Last update",
              deleteRoleSuccess: "Delete Role Success",
              alreadyInUse: "Already in use",
              cancel: "Cancel",
              delete: "Delete",
            },
            new: {
              addRole: "Add role",
              role: "Role",
              title: "General Data",
              home: "Home",
              detail: "Role detail",
              scope: "Scope Management",
              roleTitle: "Title",
              description: "Description",
              sync: "Sync Notification",
              read: "Read",
              edit: "Create / Edit / Delete",
              createAndEdit: "Create / Edit",
              editInfo: "Edit Info",
              editOnly: "Edit",
              exportReport: "Export Report",
              adminManage: "Admin Management",
              permissionManage: "Permission Management",
              masterInsurancePlanManage: "Master Insurance Plan Management",
              insuranceManagement: "Insurance Management",
              enrollmentManage: "Enrollment Management",
              frontStoreManage: "Front Store Management",
              insuranceCompanyManage: "Insurance Company Management",
              occupationManage: "Occupation Management",
              orderManage: "Order Management",
              overdueTransactionManage: "Overdue Transaction Management",
              nameChangeTransactionManage: "Name Change Transaction Management",
              brokerManage: "Broker Management",
              missionManage: "Mission Management",
              userManagement: "User Management",
              leadManage: "Lead Management",
              insuranceTransactionManage: "Insurance Transaction Management",
              paymentTransactionManage: "Payment Transaction Management",
              reportManage: "Report Management",
              notificationManage: "Notification Management",
              workspaceManage: "Workspace Management",
              settingManage: "Setting Management",
              cancel: "cancel",
              save: "Save",
              cancelEdit: "Cancel Edit",
              cancelConfirm:
                "Current data will not be saved. and cannot be restored",
              close: "Close Window",
              canceledEdit: "Canceled Edit",
            },
            edit: {
              indexTitle: "Role",
              home: "Home",
              role: "Role",
              editRole: "Edit role",
              cancelEdit: "Cancel Edit",
              cancelConfirm:
                "Current data will not be saved. and cannot be restored",
              close: "Close Window",
              canceledEdit: "Canceled Edit",
              detail: "Role detail",
              scope: "Scope Management",
              cancel: "cancel",
              save: "Save",
              roleTitle: "Title",
              description: "Description",
            },
          },
          insurances: {
            index: {
              home: "Home",
              title: "Manage Package & Weight",
              addButton: "Add Insurance",
              list: "Manage Package & Weight",
              name: "Name",
              year: "Years",
              amount: "Amount of Insurance",
              updatedAt: "Last update",
              status: "State",
              modalDescription:
                "Please specify the year. (Year must not be the same as already existing in the system)",
              duplicateTitle: "Duplicate Insurance",
              duplicateDescription:
                "The system will copy the insurance set <b>{{year}}</b> to create a new insurance set prototype for further editing and use. Please specify the year of use.",
              cancel: "Cancel",
              duplicateSuccess: "Duplicate success",
              alreadyInUse: "Already in use",
              reset: "Reset",
              filter: "Filter",
              reEditing: "Modify the published insurance",
              reEditingInfo:
                "The modifications might affect the existing Enrollment in the system. Do you want to proceed ?.",
              edit: "edit",
              deleteTitle: "Delete Insurance",
              deleteSuccess: "Delete success",
              deleteDescription: "Delete Insurance {{year}}",
              state: {
                all: "All",
                draft: "Draft",
                published: "published",
                publishing: "publishing",
                editing: "Editing",
                active: "Active",
                closed: "Close",
              },
            },
            package: {
              new: {
                save: "Save",
                cancel: "Cancel",
                name: "Package Name",
                ipd: "IPD",
                opd: "OPD",
                dental: "Dental",
                remark: "Remark",
              },
            },
          },
          settings: {
            index: {
              home: "Home",
              settingMenu: "Setting Menu",
              title: "Setting Info About Belive",
              titleDetail:
                "Details will be displayed in the Settings -> About Belive page of the application.",
              logo: "Logo",
              logoDetail:
                "Recommended to use a .jpg image with at least xxx x yyy px size.",
              syncSetting: "Sync settings for employee data.",
              syncSettingDetail:
                "Employee information will be used in HR's Enrollment creation process.",
              reportSetting: "Automatic report generate setting.",
              reportSettingDetail:
                "Use in the automatic report generate process of the system.",
              createReport: "Create Report Every",
              addImage: "Add Image",
              editImage: "Edit Image",
              hostUrl: "Host URL",
              port: "Port",
              username: "Username",
              password: "Password",
              name: "Company Name",
              nameTh: "Company Name (Th)",
              nameEn: "Company Name (En)",
              description: "Company Description",
              descriptionTh: "Company Description (Th)",
              descriptionEn: "Company Description (En)",
              email: "Email",
              phoneNumber: "Phone number",
              cancel: "Cancel",
              save: "Save",
              saveSuccess: "Save Success",
              syncEmData: "Sync Employees Data Every",
              cancelEdit: "Cancel Edit",
              cancelConfirm:
                "Current data will not be saved. and cannot be restored",
              close: "Close Window",
              canceledEdit: "Canceled Edit",
            },
          },
          reports: {
            index: {
              home: "Home",
              reportMenu: "Report Menu",
              columns: {
                year: "Year",
                insuranceCompanyName: "Insurance company",
                createReportDate: "Create date",
                outgoingCustomerAmount: "Outgoing",
                incomingCustomerAmount: "Incoming",
                sendStatus: "State",
              },
              modal: {
                title: "Change report state",
                description: "Change report state to",
                statusSend: "sent",
                statusNotSend: "unsent",
                cancelButtonLabel: "Cancel",
                okButtonLabel: "Confirm ",
              },
            },
          },
          marketplaceReports: {
            index: {
              home: "Home",
              reportMenu: "Report Menu",
              columns: {
                year: "Year",
                insuranceCompanyName: "Insurance company",
                createReportDate: "Create date",
                outgoingCustomerAmount: "Outgoing",
                incomingCustomerAmount: "Incoming",
                sendStatus: "State",
              },
              modal: {
                title: "Change report state",
                description: "Change report state to",
                statusSend: "sent",
                statusNotSend: "unsent",
                cancelButtonLabel: "Cancel",
                okButtonLabel: "Confirm ",
              },
            },
          },
          insuranceCompanies: {
            index: {
              home: "Home",
              title: "Add/Remove Insurance Company",
              header: "Add/Remove Insurance Company",
              addInsuranceCompany: "Add Insurance Company",
              reset: "Reset",
              filter: "Filter",
              name: "name",
              status: "status",
              updatedAt: "Updated at",
              columnStatus: {
                all: "All",
                active: "Active",
                closed: "Closed",
              },
              deleteInsuranceCompany: "Delete Insurance Company",
              insuranceCompanyInfo: "Insurance Company Info",
              cannotBeRestored: "will be deleted and cannot be restored",
              cancel: "Cancel",
              delete: "Delete",
              notificationSuccess: "successful transaction",
            },
            new: {
              home: "Home",
              rootPath: "Insurance Company",
              title: "Add Insurance Company",
              header: "Insurance Company Info",
              active: "Active",
              save: "Create",
              cancel: "Cancel",
              name: "Name",
              description: "Description",
              notificationSuccess: "successful transaction",
              email: "Email",
              phoneNumber: "Phone Number",
              uploadLogo:
                "Company Logo for Display on the Application <b>*</b>",
              uploadLgoDescription:
                "Supports .jpg, .png files / Recommended 256x256 px / File size must not exceed 5 MB",
              addFile: "Attach Files",
              requiredLogo: "Need to always upload logo",
              gracePeriodTitle: "Grace Period",
              gracePeriodHelp:
                "If payment is overdue beyond the set period, the system will automatically change the policy status to 'Lapsed' (or 'Terminated')",
              broker: "Broker",
              confirm: "Confirm",
            },
            edit: {
              home: "Home",
              rootPath: "Insurance Company",
              header: "Insurance Company Info",
              active: "Active",
              save: "Save",
              cancel: "Cancel",
              name: "Name",
              description: "Description",
              notificationSuccess: "successful transaction",
              email: "Email",
              phoneNumber: "Phone Number",
              uploadLogo: "Company Logo for Display on the Application",
              uploadLgoDescription:
                "Supports .jpg, .png files / Recommended 256x256 px / File size must not exceed 5 MB",
              addFile: "Attach Files",
              requiredLogo: "Need to always upload logo",
              gracePeriodTitle: "Grace Period",
              gracePeriodHelp:
                "If payment is overdue beyond the set period, the system will automatically change the policy status to 'Lapsed' (or 'Terminated')",
              broker: "Broker",
              tab1: "Insurance Company Info",
              tab2: "Questions before buying insurance",
              tab3: "See Information Permission",
            },
            question: {
              index: {
                header: "List of questions",
                question: "Question",
                updatedAt: "Updated at",
                reset: "Reset",
                filter: "Filter",
                addQuestion: "Add Question",
                deleteQuestion: "Delete Question",
                cannotBeRestored: "will be deleted and cannot be restored",
                cancel: "Close",
                delete: "Delete",
                notificationSuccess: "successful transaction",
              },
              new: {
                title: "Add Question",
                home: "Home",
                rootPath: "Insurance Company",
                header: "Question info",
                save: "Save",
                cancel: "Cancel",
                question: "Question",
                choices: "Choices",
                choicesInstruction1:
                  "Please select the Checkbox in front of the choice that is the answer to the question",
                choicesInstruction2:
                  "The system will verify and prevent those who answer incorrectly from proceeding to the next step of purchasing insurance",
                autoCorrectChoice: "Auto-correct choice",
                notificationSuccess: "successful transaction",
              },
              edit: {
                title: "Question Detail",
                home: "Home",
                rootPath: "Insurance Company",
                header: "Question info",
                save: "Save",
                cancel: "Cancel",
                question: "Question",
                choices: "Choices",
                choicesInstruction1:
                  "Please select the Checkbox in front of the choice that is the answer to the question",
                choicesInstruction2:
                  "The system will verify and prevent those who answer incorrectly from proceeding to the next step of purchasing insurance",
                autoCorrectChoice: "Auto-correct choice",
                notificationSuccess: "successful transaction",
              },
              ChoiceList: {
                answerRequiredWhenAutoCorrect:
                  "Please select the choice that is the correct answer",
                choiceLabel: "Choice",
                addChoice: "Add choice",
                title: "Delete choice",
                cancel: "Close",
                choice: "Choice",
                cannotBeRestored: "will be deleted and cannot be restored",
              },
            },
            transactionsPermission: {
              index: {
                header: "List of authorized users to see the information.",
                addUser: "Add User",
                code: "Code",
                fullname: "Name and Surname",
                role: "Role",
                notFound: "No one has permission to see the information.",
                deleteTitle:
                  "Remove users who have permission to see the information.",
                eligible: "Eligible persons",
                cannotBeRestored: "will be deleted and cannot be restored",
                cancel: "Cancel",
                delete: "Delete",
                notificationSuccess: "successful transaction",
              },
              AddAdminsModal: {
                title: "List of Admins",
                code: "Code",
                fullname: "Name and Surname",
                role: "Role",
                close: "Cancel",
                save: "Choose",
                notificationSuccess: "successful transaction",
              },
            },
          },
          occupation: {
            index: {
              title: "Add/Remove Occupation",
              table: "Add/Remove Occupation",
              home: "Home",
              addButton: "Add Occupation",
              deleteOccupation: "Delete Occupation",
              occupationInfo: "Occupation",
              cannotBeRestored: "will be deleted and cannot be restored",
              cancel: "Close",
              delete: "Delete",
              notificationSuccess: "successful transaction",
              filters: {
                firstName: "Name",
                class: "Occupation Class",
                classAll: "All",
                isActiveTitle: {
                  title: "Status",
                  isActiveAll: "All",
                  true: "Active",
                  false: "Inactive",
                },
                isActiveAll: "All",
              },
              columns: {
                name: "Name",
                class: "Occupation Class",
                isActiveTitle: {
                  title: "Status",
                  isActiveAll: "All",
                  true: "Active",
                  false: "Inactive",
                },
                updatedAt: "Updated at",
              },
              reset: "Reset",
              filter: "Filter",
            },
            new: {
              title: "Add Occupation",
              title2: "Occupation",
              home: "Home",
              addButton: "Add Occupation",
              header: "Occupation Info",
              active: "Active",
              name: "Name",
              class: "Occupation Class",
              cancel: "Cancel",
              submit: "Create",
              notificationSuccess: "successful transaction",
            },
            edit: {
              title: "Add Occupation",
              title2: "Occupation",
              home: "Home",
              addButton: "Add Occupation",
              header: "Occupation Info",
              active: "Active",
              name: "Name",
              class: "Occupation Class",
              cancel: "Cancel",
              submit: "save",
              notificationSuccess: "successful transaction",
            },
          },
          dynamicConfig: {
            index: {
              title: "Insurance Sales Information",
              home: "Home",
              save: "Save",
              saveSuccess: "successful transaction",
              fontFamily: "fontFamily",
              fontFamilyDescription:
                "Enter the font URL from the googlefont.com website such as https://fonts.google.com/specimen/Roboto",
              primary: "primary",
              primaryAccent: "primaryAccent",
              secondary: "secondary",
              secondaryAccent: "secondaryAccent",
              mainText: "mainText",
              subText: "subText",
              success: "success",
              info: "info",
              warning: "warning",
              error: "error",
              other1: "other1",
              other2: "other2",
              white: "white",
              otherAccent: "otherAccent",
              group1: "1. Font",
              group2: "2. Theme colors",
              group3: "3. How to use",
              group4: "4. Home",
              group5: "5. Terms and conditions",
              group6: "6. Identity verification",
              group7: "7. Customize insurance",
              group8: "8. Payment",
              group9: "9. User profile",
              group10: "10. Contact information",
              group11: "11. Insurance description",
              group12: "12. Forgot password",
              group13: "13. Notifications",
              group14: "14. Policy",
              group15: "15. Display when system is under maintenance",
              loadingImageTitle: "[3.1] App loading image",
              appVersionDescription:
                "Image .jpg, .svg file size not exceeding 1 MB (recommended 485 x 485 pixel)",
              appVersionTitle: "[3.2] App version",
              mainLogoTitle: "[3.3] Main logo",
              mainLogoDescription:
                "Image .jpg, .svg file size not exceeding 1 MB (recommended 169 x 30 pixel)",
              quickTourTitle: "Quick Tour list",
              quickTourImageTitle: "[3.4] Image",
              quickTourTitleTitle: "[3.5] Title",
              quickTourInfoTitle: "[3.6] Description",
              heroBannerTitle: "Banner list",
              heroBannerImageTitle: "[4.1] Image",
              heroBannerTitleTitle: "[4.2] Title",
              heroBannerInfoTitle: "[4.3] Description",
              heroBannerLinkUrlTitle: "[4.4] URL",
              backgroundImageTitle: "[4.5] Insurance purchase method image",
              backgroundImageDescription:
                "Image .jpg, .svg file size not exceeding 1 MB (recommended 154 x 154 pixel)",
              tutorialImageTitle: "[4.6] Banner background image",
              tutorialImageDescription:
                "Image .jpg, .svg file size not exceeding 1 MB (recommended 374 x 238 pixel)",

              tcTitle: "[5.1] T&C title",
              tcInfo: "[5.2] T&C description",
              tcConsentMessage: "[5.3] T&C consent message",
              kycBannerEmailTitle: "[6.1] KYC banner: Enter email",
              kycDescription:
                "Image .jpg, .svg file size not exceeding 1 MB (recommended 375 x 175 pixel)",
              kycBannerOtpTitle: "[6.2] KYC banner: Enter OTP",
              kycBannerPersonalInfoTitle:
                "[6.3] KYC banner: Personal information",
              kycBannerConfirmPhoneNumberTitle:
                "[6.4] KYC banner: Confirm phone number",
              kycBannerSuccessTitle: "[6.5] KYC banner: Transaction success",
              kycHeaderSuccessTitle: "[6.6] KYC success title",
              kycInfoSuccessTitle: "[6.7] KYC success description",
              customIntroImageTitle: "[7.1] Intro page image",
              customIntroTitleTitle: "[7.2] Intro page title",
              customIntroInfoTitle: "[7.3] Intro page description",
              customDetailImageTitle: "[7.4] Customize page image",
              customDetailImageDescription:
                "Image .jpg, .svg file size not exceeding 1 MB (recommended 96 x 96 pixel)",
              customDetailTitleTitle: "[7.5] Customize page title",
              customDetailInfoTitle: "[7.6] Customize page description",
              notificationTitle: "[7.7] Title when premium calculation fails",
              notificationInfo:
                "[7.8] Description when premium calculation fails",
              buyInsuranceMultipleCompaniesImageTitle:
                "[7.9] Multi-company insurance purchase page image",
              buyInsuranceMultipleCompaniesDescription:
                "Image .jpg, .svg file size not exceeding 1 MB (recommended 226 x 226 pixel)",
              customNoInsurancePlanImageTitle:
                "[7.10] Customize page image when no insurance plan found",
              customNoInsurancePlanImageDescription:
                "Image .jpg, .svg file size not exceed 1 MB (recommend 96 x 96 pixel)",
              customNoInsurancePlanTitleTitle:
                "[7.11] Customize page title when no insurance plan found",
              customNoInsurancePlanInfoTitle:
                "[7.12] Customize page description when no insurance plan found",
              paySuccessImageTitle: "[8.1] Payment success image",
              paySuccessTitle: "[8.2] Payment success title",
              paySuccessInfo: "[8.3] Payment success description",
              paySuccessInfo2: "[8.4] Payment success description 2",
              payFailedImageTitle: "[8.5] Payment failed image",
              payFailedTitle: "[8.6] Payment failed title",
              payFailedInfo: "[8.7] Payment failed description",
              payFailedInfoDescription:
                "You can insert system variables into the message as follows:\n• For payment date, use {{payment_date}}",
              defaultProfileImageTitle: "[9.1] Default profile image",
              defaultProfileDescription:
                "Image .jpg, .svg file size not exceeding 1 MB (recommended 100 x 100 pixel)",
              aboutUsInfoTitle: "[9.2] About us information",
              aboutUsTelNoTitle: "[9.3] Contact phone number",
              aboutUsEmailTitle: "[9.4] Contact email",
              notLoginImageTitle: "[9.5] Image when not logged in",
              notLoginImageDescription:
                "Image .jpg, .svg file size not exceeding 1 MB (recommended 226 x 226 pixel)",
              notLoginMessageTitle: "[9.6] Message when not logged in",
              faqTitle: "FAQ list",
              faqCategoryTitle: "[9.7] Category",
              faqQuestionTitle: "[9.8] Question",
              faqAnswerTitle: "[9.9] Answer",
              tutorialStepTitle: "Purchase steps",
              contactProcessImageTitle: "[10.1] Purchase step image",
              contactProcessImageDescription:
                "Image .jpg, .svg file size not exceeding 1 MB (recommended 92 x 82 pixel)",
              purchaseProcessTitleTitle: "[10.2] Purchase step title",
              purchaseProcessInfoTitle: "[10.3] Purchase step description",
              tutorialStepImageTitle: "[10.4] Image",
              tutorialStepImageDescription:
                "Image .jpg, .svg file size not exceeding 1 MB (recommended 85 x 85 pixel)",
              tutorialStepStepTitle:
                "[10.5] Step (No need to add a number - the system will assign the order automatically)",
              tutorialStepTitleTitle: "[10.6] Title",
              tutorialStepInfoTitle: "[10.7] Description",
              accidentTitle: "[11.1] Accident insurance benefit title",
              accidentTitleTooltip: "[11.2] Accident insurance title tooltip",
              accidentInfoTooltip:
                "[11.3] Accident insurance description tooltip",
              ciTitle: "[11.4] CI insurance benefit title",
              ciTitleTooltip: "[11.5] CI insurance title tooltip",
              ciInfoTooltip: "[11.6] CI insurance description tooltip",
              ipdTitle: "[11.7] IPD insurance benefit title",
              ipdTitleTooltip: "[11.8] IPD insurance title tooltip",
              ipdInfoTooltip: "[11.9] IPD insurance description tooltip",
              opdTitle: "[11.10] OPD insurance benefit title",
              opdTitleTooltip: "[11.11] OPD insurance title tooltip",
              opdInfoTooltip: "[11.12] OPD insurance description tooltip",
              wellnessTitle: "[11.13] Wellness insurance benefit title",
              wellnessTitleTooltip: "[11.14] Wellness insurance title tooltip",
              wellnessInfoTooltip:
                "[11.15] Wellness insurance description tooltip",
              annuityTitle: "[11.16] Annuity insurance benefit title",
              annuityTitleTooltip: "[11.17] Annuity insurance title tooltip",
              annuityInfoTooltip:
                "[11.18] Annuity insurance description tooltip",
              forgetPassBanner1Title:
                "[12.1] Forgot password banner: Enter email",
              forgetPassBanner2Title:
                "[12.2] Forgot password banner: Set new password",
              forgetPassBanner3Title:
                "[12.3] Forgot password banner: Password changed successfully",
              forgetPassBannerDescription:
                "Image .jpg, .svg file size not exceeding 1 MB (recommended 375 x 175 pixel)",
              noNotificationImageTitle: "[13.1] Image when no notifications",
              noNotificationMessageTitle:
                "[13.2] Message when no notifications",
              noNotificationImageDescription:
                "Image .jpg, .svg file size not exceeding 1 MB (recommended 226 x 226 pixel)",
              emptyPolicyImageTitle: "[14.1] Image when no policy",
              emptyPolicyImageDescription:
                "Image .jpg, .svg file size not exceeding 1 MB (recommended 226 x 226 pixel)",
              emptyPolicyMessageTitle: "[14.2] Message when no policy",
              maintenanceImageTitle:
                "[15.1] Image when system is under maintenance",
              maintenanceImageDescription:
                "Image .jpg, .svg file size not exceeding 1 MB (recommended 485 x 485 pixel)",
            },
          },
          workspace: {
            index: {
              title: "Manage Work Space",
              home: "Home",
              addButton: "Add WorkSpace",
              table: "Manage WorkSpace",
              deleteWorkspace: "Delete WorkSpace",
              workspaceInfo: "WorkSpace Info",
              cannotBeRestored: "will be deleted and cannot be restored",
              cancel: "Close",
              delete: "Delete",
              notificationSuccess: "successful transaction",
              filters: {
                workspace: "Workspace",
                isActive: "Status",
                statusAll: "All",
                statusActive: "Active",
                statusInactive: "Inactive",
              },
              columns: {
                workspace: "Workspace",
                isActive: "Status",
                statusValues: {
                  true: "Active",
                  false: "Inactive",
                },
                description: "Description",
                updatedAt: "Updated at",
              },
              reset: "Reset",
              filter: "Filter",
            },
            new: {
              title: "Add Work Space",
              title2: "Manage Work Space",
              home: "Home",
              addButton: "Add Work Space",
              header: "Work Space Info",
              active: "Active",
              name: "Name",
              description: "Description",
              cancel: "Cancel",
              submit: "Create",
              notificationSuccess: "successful transaction",
            },
            edit: {
              title: "Edit Work Space",
              home: "Home",
              addButton: "Add Work Space",
              header: "Work Space Info",
              active: "Active",
              title2: "Manage Work Space",
              name: "Name",
              description: "Description",
              cancel: "Cancel",
              submit: "Save",
              notificationSuccess: "successful transaction",
            },
          },
          masterInsurancePlans: {
            detail: {
              index: {
                title: "Insurance Plan",
                breadcrumbs: {
                  home: "Home",
                  masterInsurancePlanList: "Add/Remove Insurance Plan",
                },
              },
              DetailPage: {
                cancel: "Cancel",
                save: "Save",
              },
            },
            index: {
              addInsurancePlan: "Add Insurance Plan",
              addButton: "Insurance Plan",
              home: "Home",
              title: "Add/Remove Insurance Plan",
              all: "All",
              list: "Add/Remove Insurance Plan",
              name: "Insurance Plan Name",
              company: "Insurance Company",
              type: "Type",
              version: "Version Used",
              updatedAt: "Last Updated",
              cancel: "Cancel",
              confirm: "Confirm",
              notInUse: "Draft",
              filter: {
                reset: "Reset",
                filter: "Filter",
              },
              modal: {
                form: "Choose how to fill out insurance details",
                freelance: {
                  title: "Detailed field breakdown",
                  helperText: "The new form is for freelance clients",
                },
                enterprise: {
                  title: "Single-field Markdown",
                  helperText: "The default format is for Enterprise customers",
                },
              },
              deleteTitle: "Delete Insurance Plan",
              deleteMessage:
                "Insurance Plan <b>{{name}}</b> will be deleted and cannot be recovered",

              close: "Close",
              deleteInfo: "Delete",
              deleteSuccess: "Successfully deleted insurance plan",
              copy: "Copy",
              publishedVersionEditModal: {
                title: "Edit published version",
                description:
                  "Select insurance data to display in Application \n (If set to draft, this insurance will not be displayed in the App)",
                fieldName: "Version in use",
                confirm: "Confirm",
                cancel: "Cancel",
                error: "Not ready",
                notInUse: "Draft",
                errorMessages:
                  "Some information is incomplete. Please check the following data",
                warningMessage: {
                  title:
                    "The changes will affect insurance packages and registration cycles related to insurance plans as follows:",
                  1: {
                    header: "Effective immediately",
                    description:
                      "when you switch to a different version, the new information will be displayed on the Front Store immediately.",
                  },
                  2: {
                    header: "No retroactive effect",
                    description:
                      "for all previous orders and policies (to update already purchased insurance policies to the latest version, please edit the information in the Policy menu item by item).",
                  },
                },
              },
              createNewVersionTitle: "Create new version",
              createNewVersionMessage:
                "Since the version you want to edit is currently in use in Application \n The system will automatically create the next version for editing",
              noVersionOptions:
                "No other versions available. Please click edit to create a new version",
              publishSuccess: "Successfully completed",
            },
            components: {
              duplicateModal: {
                title: "Copy Insurance Plan",
                content: "The system will copy the insurance plan",
                content2:
                  "to create a new insurance plan prototype. Please verify details",
                duplicateName: "Insurance plan name",
                insuranceType: "Type",
                insuranceCompany: "Insurance Company",
                confirm: "Copy Insurance Plan",
                cancel: "Cancel",
                duplicateSuccess: "Successfully completed",
                copy: "copy",
              },
              freelance: {
                CustomPackage: {
                  info: "Numbers for Slider",
                  budget: "Amount (Baht)",
                  critical_illness_benefit: "Critical Illness Coverage",
                  ipd_benefit: "Inpatient medical expenses (IPD)",
                  opd_benefit: "OPD Coverage",
                  opd_plus_benefit: "Outpatient medical expenses (OPD+)",
                  ad_and_benefit: "Life/Accident Coverage (AD&D)",
                  annuity_5_benefit: "Annuity",
                  annuity_10_benefit: "Annuity",
                  annuity_to_60_benefit: "Annuity",
                  annuity_benefit: "Annuity",
                  amount: "Amount",
                  description: "Details",
                  sum_insured: "Sum Insured",
                  pass_away_by_accident: "Death by accident",
                  save: "Save",
                  cancel: "Cancel",
                  success: "successful transaction",
                  insuranceDescription: "Insurance description",
                  insuranceBenefitDetail: "Insurance benefit details",
                  publishCondition: {
                    title:
                      "Conditions for publishing an insurance plan: all of the following fields must be completed.",
                    benefitDetailBullet:
                      "Insurance benefit details field in the Insurance description section",
                    amountBullet:
                      "Amount (Baht) field in the Numbers for Slider section",
                  },
                },
                CompensationTable: {
                  save: "Save",
                  cancel: "Cancel",
                  success: "Successful transaction",
                  age: "Age",
                  class1: "Occupation Class 1",
                  class2: "Occupation Class 2",
                  class3: "Occupation Class 3",
                  class4: "Occupation Class 4",
                  male: "Male",
                  female: "Female",
                  readOnlyAlert: "This cell is read-only and cannot be edited.",
                  readOnlyAlertTitle: "Cannot Edit",
                  validationErrorTitle: "An Error Occurred",
                  validationErrorAlert:
                    "The data cannot be saved because it contains non-numeric characters. Please review the data and try again.",
                  validationErrorRetry: "Go Back to Edit",
                  validationErrorCancel: "Cancel",
                  publishCondition:
                    "Conditions for publishing an insurance plan: at least 1 premium field in the policy table must be filled in.",
                },
                RiderConfigSection: {
                  cancel: "Cancel",
                  save: "Save",
                  notificationSuccess: "successful transaction",
                },
                RiderConfigList: {
                  additionalContract: "Additional contract",
                  description:
                    "Specify the additional insurance contract that is linked to this insurance (the condition is that you must purchase this insurance first before purchasing the additional insurance contract).",
                  addItem: "Add Item",
                  item: "Item {{index}}",
                  insuranceCompany: "Insurance Company",
                  insuranceType: "Insurance Type",
                  insuranceName: "Insurance Name",
                  title: "Delete additional contracts",
                  deleteDescription:
                    "Do you want to delete this additional contract?",
                  cancel: "Cancel",
                },
                SettingCondition: {
                  salesCriteria: {
                    title: "Sales criteria",
                    description:
                      "This insurance is an additional contract (Rider).",
                    caption:
                      "For supplementary contracts (involving a type of insurance that must be purchased previously), there is no need to specify the terms and conditions or questions before purchase",
                    condition: {
                      title: "If it's an additional contract",
                      1: "You must specify the type of insurance that must be purchased beforehand. For example, you may need to purchase accident insurance before you can purchase this insurance.",
                      2: "Previously purchased insurance must be from the same insurance company.",
                      3: "They must be purchased in the same order or package.",
                      4: "Supplementary insurance policies will use the same set of health questions as the main insurance policy.",
                    },
                  },
                  cancel: "Cancel",
                  save: "Save",
                  mainInsurance: {
                    title: "Primary insurance",
                    caption:
                      "List the primary insurance policies that must be purchased before this policy.",
                    chooseButton: "Choose an insurance plan.",
                    name: "Insurance plan name",
                    type: "Insurance type",
                    noInsuranceFound: "No insurance plans found.",
                    AddMainInsuranceModal: {
                      title: "Choose a primary insurance policy.",
                      name: "Insurance plan name",
                      type: "Insurance type",
                      cancel: "Cancel",
                      choose: "Choose",
                      notificationSuccess: "successful transaction",
                      noInsuranceFound: "No insurance plans found.",
                    },
                  },
                  termsAndConditions: {
                    header: "Terms and Conditions",
                    statement: "Statement prior to the terms and conditions.",
                    title: "Title",
                    detail: "Detail",
                  },
                  question: {
                    title: "Questions before buying insurance",
                    chooseButton: "Choose a question",
                    noQuestionsFound: "No questions found.",
                    question: "Question",
                    AddQuestionModal: {
                      title: "Question",
                      noQuestionsFound: "No questions found.",
                      cancel: "Cancel",
                      choose: "Choose",
                      notificationSuccess: "successful transaction",
                    },
                  },
                  close: "Close",
                  deleteQuestion: "Delete question",
                  cannotBeRestored:
                    "will be removed from this set of questions.",
                  notificationSuccess: "successful transaction",
                  deleteMainInsurance: "Remove the primary guarantor.",
                  wantToDeleteMainInsurance: "Delete primary insurance policy",
                  orNot: "or not?",
                  publishCondition: {
                    title:
                      "Conditions for publishing an insurance plan: all of the following fields must be completed.",
                    nonRiderBullet:
                      "If it is not an additional contract, the terms and conditions must be specified and at least 1 pre-purchase question must be added.",
                    riderBullet:
                      "If it is an additional contract, at least 1 primary insurance plan must be added.",
                  },
                },
              },
              FreelanceForm: {
                saving: "Saving...",
                tab1: "Insurance Plan Details",
                tab2: "Custom Package",
                tab3: "Policy Table",
                tab4: "Setting conditions",
                cancel: "Cancel",
                save: "Save",
                updatedAt: "Last Updated",
                version: "Version",
                usingVersion: "Version in use",
                enrollmentUsing:
                  "Enrollments using this insurance package version:",
                versionDisplayOnApp: "Current version displayed on App",
                saveSuccess: "successful transaction",
                detail: {
                  info: "Plan Overview",
                  companyName: "Insurance Company",
                  insuranceName: "Insurance Plan Name",
                  remark: "Remark",
                  active: "Active",
                  addItem: "Add Item",
                  order: "Item",
                  orderName: "Item Name",
                  detail: "Details",
                  summaryTable: "Summary Table",
                  listOfBenefits: "List of Benefits",
                  compensationList: "Compensation List",
                  insurancePlanDetail: "Insurance Plan Details",
                  summaryBenefit: "Benefit Summary",
                  policyAndConditions: "Policy Terms and Conditions",
                  termsAndBenefits: "Terms and Benefits",
                  documentRequirementsAndBenefits:
                    "Document Requirements and Benefits",
                  policyInformation:
                    "Policy Information (for display in My Policy)",
                  acceptPdf: "Accepts .pdf files",
                  browseFile: "Attach File",
                  insuranceType: "Type",
                  shortDescription:
                    "Summary details (for insurance policies purchased via a link from an external website)",
                  showInPackage:
                    "Shown in package details (select 1 item from the table).",
                },
                publishCondition: {
                  title:
                    "Conditions for publishing an insurance plan: <b>if these sections are enabled, all fields in the section must be completed.</b>",
                  infoBullet: "Insurance Plan Details",
                },
                infoCustomPackage: {
                  info: "Values used to select insurance",
                  accident: {
                    byAccident: "Death by accident",
                    insuranceMoney: "Sum Insured",
                  },
                  health: {
                    ipd: "Inpatient medical expenses (IPD)",
                    opd: "OPD Plus+ (OPD+)",
                  },
                  annuity: {
                    ipd: "Inpatient medical expenses (IPD)",
                  },
                  amount: "Amount",
                  detail: "Details",
                },
                compensationTable: {
                  info: "Insurance premium",
                },
              },
              VersionControl: {
                version: "Version",
                usingVersion: "Version in use",
                enrollmentUsing:
                  "Enrollments using this insurance package version:",
                versionDisplayOnApp: "Current version displayed on App",
                updatedAt: "Last updated {{updatedAt}}",
                validateThisVersion: "Validate",
                validateThisVersionDescription:
                  "To check if this insurance version has data ready for use in Application (must save the latest edited data before validating)",
                result: "Validation Result",
                errorMessages:
                  "Some information is incomplete. Please check the following data",
                readyToPublish: "Version {{versionName}} is ready",
                notReadyToPublish: "Version {{versionName}} is not ready",
                close: "Close",
              },
              EnterpriseForm: {
                name: "Insurance Plan Name",
                info: "Insurance Plan Details",
                nameTh: "Insurance Plan Name (TH)",
                nameEn: "Insurance Plan Name (EN)",
                premium: "Premium (Baht)",
                remark: "Remark",
                remarkTh: "Remark (TH)",
                remarkEn: "Remark (EN)",
                save: "Save",
                cancel: "Cancel",
                breadcrumbs: {
                  home: "Home",
                  insurance: "Insurance Management",
                  insuranceDetail: "Insurance Set Year {{year}}",
                  ipdTitle: "IPD Insurance",
                  opdTitle: "OPD Insurance",
                  dentalTitle: "Dental Insurance",
                },
                success: "Successfully completed",
                coverageLevel: "Coverage Level",
                coverageLevelHelper:
                  "*To meet the objectives of employee benefits, if family insurance is selected, the system will filter only family insurance plans at a level lower than or equal to the coverage level selected for the employee",
                insuranceFor: "Insurance for",
                insuranceType: "Insurance Type",
                insuranceForOptions: {
                  employee: "Employee",
                  family: "Family",
                },
                addInsurance: "Add Insurance",
                FilterTableWithQueryParams: {
                  confirm: "Filter",
                  reset: "Reset",
                },
              },
              FilterTableWithQueryParams: {
                confirm: "Filter",
                reset: "Reset",
              },
            },
            customPackageFields: {
              description:
                "Enter a number only to specify the amount to be displayed in the slider when selecting a plan",
            },
          },

          paymentTransaction: {
            index: {
              home: "Home",
              title: "Payment Transaction Summary",
              filter: {
                input: {
                  employeeName: "Customer Name",
                  insurancePlan: "Insurance Plan Set",
                  masterInsuranceId: "Master Insurance Plan",
                  enrollmentId: "Enrollment Round",
                  status: "Status",
                  startPaymentDate: "Payment Start Date",
                  endPaymentDate: "To Date",
                  paymentMethod: "Payment Method",
                  paymentType: "Payment Type",
                },
                status: {
                  all: "All",
                  [PaymentTransactionStatusEnum.PENDING]: "Pending",
                  [PaymentTransactionStatusEnum.SUCCESS]: "Success",
                  [PaymentTransactionStatusEnum.FAILED]: "Failed",
                },
                paymentMethodEnum: {
                  all: "All",
                  [EnumPaymentMethod.BANK_TRANSFER]: "Bank Transfer",
                  [EnumPaymentMethod.CREDIT_CARD]: "Credit Card",
                  [EnumPaymentMethod.QR_PROMPTPAY]: "QR PromptPay",
                  [EnumPaymentMethod.MONTHLY_CREDIT_CARD]:
                    "Monthly Credit Card",
                  [EnumPaymentMethod.MONTHLY_BANK_KBANK]:
                    "Monthly via Kasikorn Bank",
                  [EnumPaymentMethod.MONTHLY_BANK_KTB]:
                    "Monthly via Krungthai Bank",
                  [EnumPaymentMethod.MONTHLY_BANK_SCB]:
                    "Monthly via Siam Commercial Bank",
                },
                paymentCategoryEnum: {
                  all: "All",
                  [PaymentCategoryEnum.PAY_INSURANCE_PREMIUM]:
                    "Pay insurance premiums",
                },
              },
              button: {
                reset: "Reset",
                filter: "Filter",
              },
              table: {
                employeeName: "Customer Name",
                insurancePlan: "Insurance Plan Set",
                enrollmentName: "Enrollment Round",
                agreementInstallmentNumber: "Installment No.",
                masterInsuranceName: "Master Insurance Plan Set",
                amount: "Payment Amount (Baht)",
                status: "Status",
                paymentDate: "Payment Date",
                updatedAt: "Last Updated Date",
                transactionRef: "Transaction Ref",
                paymentMethod: "Payment Method",
                paymentType: "Payment Type",
              },
              export: "Export report",
            },
            detail: {
              home: "Home",
              title: "Payment Transaction Summary",
              insuranceTransactionInfo: {
                title: "Payment information",
                gatewayRefId: "Reference code",
                ownerName: "Payer",
                paymentType: "Payment type",
                paymentInstallment: "Payment installments",
                paymentMethod: "Payment method",
                amount: "Payment amount",
                status: "Status",
                paymentDate: "Payment date",
                paymentMethodEnum: {
                  all: "All",
                  [EnumPaymentMethod.BANK_TRANSFER]: "Bank Transfer",
                  [EnumPaymentMethod.CREDIT_CARD]: "Credit Card",
                  [EnumPaymentMethod.QR_PROMPTPAY]: "QR PromptPay",
                  [EnumPaymentMethod.MONTHLY_CREDIT_CARD]:
                    "Monthly Credit Card",
                  [EnumPaymentMethod.MONTHLY_BANK_KBANK]:
                    "Monthly via Kasikorn Bank",
                  [EnumPaymentMethod.MONTHLY_BANK_KTB]:
                    "Monthly via Krungthai Bank",
                  [EnumPaymentMethod.MONTHLY_BANK_SCB]:
                    "Monthly via Siam Commercial Bank",
                },
                statusEnum: {
                  [PaymentTransactionStatusEnum.PENDING]: "Pending",
                  [PaymentTransactionStatusEnum.SUCCESS]: "Success",
                  [PaymentTransactionStatusEnum.FAILED]: "Failed",
                },
                baht: "{{amount}} THB",
                relation: "The relationship of the insurance premium payer",
                relationEnum: {
                  self: "Self",
                  [EnumRelationship.Father]: "Father",
                  [EnumRelationship.Mother]: "Mother",
                  [EnumRelationship.Child]: "Child",
                  [EnumRelationship.Spouse]: "Spouse (Registered)",
                  [EnumRelationship.LifePartner]: "Life Partner (Unregistered)",
                },
                remark: "Because",
                paymentTypeEnum: {
                  [EnumPaymentScheduleMethod.INSTALLMENT]:
                    "Automatic billing cycle / Subscription",
                  [EnumPaymentScheduleMethod.PAY_BY_SELF]: "Pay by self",
                },
                paymentInstallmentEnum: {
                  monthly: "Monthly",
                },
              },
              paymentTransactionInfo: {
                title: "Payment Information",
                agreementInstallmentNumber: "Installment No.",
                installmentPaymentAmount:
                  "Payment Amount Per Installment (Baht)",
                status: "Status",
                paymentMethod: "Payment Channel",
                installmentPaymentDate: "Payment Date",
                updatedAt: "Last Updated",
                periodNo: "Payment Amount Per Period (Baht)",
                paymentType: "Payment Channel",
                paymentDate: "Payment Date",
                insuranceInfo: {
                  title: "Insurance Name",
                  companyName: "Insurance Company",
                  paymentAmountPerPeriod: "Payment Amount Per Period (Baht)",
                },
                statusEnum: {
                  [PaymentTransactionStatusEnum.PENDING]: "Pending",
                  [PaymentTransactionStatusEnum.SUCCESS]: "Success",
                  [PaymentTransactionStatusEnum.FAILED]: "Failed",
                },
                paymentMethodEnum: {
                  // [EnumPaymentMethod.BANK_TRANSFER]: "Bank Transfer",
                  [EnumPaymentMethod.CREDIT_CARD]: "Credit Card",
                  // [EnumPaymentMethod.DEBIT_CARD]: "Debit Card",
                  [EnumPaymentMethod.QR_PROMPTPAY]: "QR PromptPay",
                  [EnumPaymentMethod.MONTHLY_CREDIT_CARD]:
                    "Monthly Credit Card",
                  [EnumPaymentMethod.MONTHLY_BANK_KBANK]:
                    "Monthly via Kasikorn Bank",
                  [EnumPaymentMethod.MONTHLY_BANK_KTB]:
                    "Monthly via Krungthai Bank",
                  [EnumPaymentMethod.MONTHLY_BANK_SCB]:
                    "Monthly via Siam Commercial Bank",
                },
                paymentCategoryEnum: {
                  all: "All",
                  [PaymentCategoryEnum.PAY_INSURANCE_PREMIUM]:
                    "Pay insurance premiums",
                },
              },
              masterInsurancePlans: {
                name: "Insurance Name",
                companyName: "Insurance Company",
                amount: "Payment Amount Per Period (Baht)",
              },
              back: "Back",
              baht: "thb",
              broker: "Broker:",
            },
          },
          insuranceTransaction: {
            components: {
              changeVersionInsuranceModal: {
                title: "Change Version of Each Insurance",
                description:
                  "You can filter the options for the version you want to change for ease of use.",
                description2:
                  "The option to select the insurance version will only display items with complete information, excluding versions that are drafts.",
                usingVersion: "Current Version in Use",
                version: "Version: {{version}}",
                cancel: "Cancel",
                ok: "Confirm",
                helperText: "The current version used displayed on the App",
                success: "Transaction Completed.",
              },
              confirmToChangeVersionModal: {
                title: "Confirm Version Change",
                description:
                  "Changing the version will affect the policy details of each insurance.",
                close: "Close Window",
                changeVersion: "Change Version",
              },
            },
            index: {
              home: "Home",
              title: "Policy Status",
              header: "Policy Status",
              filter: {
                name: "Insured's name, Policy number",
                insurance: "Policy name",
                insuranceCompany: "Insurance Company",
                version: "Version",
                startBuyDate: "Buy Date Start",
                endBuyDate: "To Date",
                updatedAt: "Last Updated",
                status: "Status",
                requestId: "Order Request ID - Group",
                buyDate: "Purchase Date",
              },
              table: {
                name: "Name of the insured",
                insurance: "Policy name",
                insuranceCompany: "Insurance Company",
                version: "Version",
                policyNumber: "Policy Number",
                requestId: "Order Request ID - Group",
                buyDate: "Purchase Date",
                updatedAt: "Last Updated",
                status: "Status",
                isMain: "Main",
              },
              changeVersion: "Change Insurance Version",
              status: {
                all: "All",
              },
              EditStatusModal: {
                title: "Adjust insurance policy status.",
                cancel: "Cancel",
                confirm: "Confirm",
                state: "Insurance policy status",
                of: "of",
              },
            },
            edit: {
              home: "Home",
              rootPath: "Insurance transaction",
              modal: {
                title: "Do you want to change the version",
                title2: "Change Version for Each Insurance",
                description:
                  "Changing the version will affect the policy details of each insurance.",
                description2:
                  "You can filter the options you want to change the version for ease of use.",
                close: "Close this window",
                next: "Change Version",
                version: "Version: {{version}}",
                usingVersion: "Current Version in Use",
                cancel: "Cancel",
                ok: "Confirm",
                latest: "Latest",
                helperText: "The current version used displayed on the App",
              },
            },
            detail: {
              home: "Home",
              rootPath: "Insurance Transactions",
              header: "Insurance policy information",
              insuranceInfo: {
                title: "Insurance Info",
              },
              currentVersion: "Latest",
              notificationSuccess: "Successful transaction",
              form: {
                name: "Name of the insured",
                insurance: "Policy name",
                enrollmentName: "Enrollment",
                insuranceCompany: "Insurance Company",
                insuranceType: "Insurance Type",
                premiumPerMonth: "Premium per Month (THB)",
                usingVersion: "Current Version in Use",
                buyDate: "Purchase Date",
                expireDate: "Expiration Date",
                registerPurchase: "Purchase Registration",
                updatedAt: "Last Updated",
                back: "Back",
                viewInsuranceDetailPage: "View Insurance Detail Page",
                viewPolicyPage: "View My Policy Page",
                helperText: "The current version used displayed on the App",
                status: "Policy status",
                applicationNumber: "Application number",
                save: "Save",
                policyNumber: "Policy Number",
                startContractDate: "Date of application for insurance policy",
                applicationDate: "Date of insurance contract",
                endContractDate: "Insurance policy expiration date",
                insuranceCompanyReceivedDate:
                  "Date the company received the insurance policy (Freelook)",
                group: "Group",
                isMain: "Is main insurance",
                isMainText: {
                  yes: "Yes",
                  no: "No",
                },
              },
              confirmChangeVersion: {
                title: "Do you want to change the version",
                description:
                  "Change version from {{currentVersion}} to version {{newVersion}}. Changing the version will affect the policy details.",
                beforeChange:
                  "You can view version {{newVersion}} information before actually changing.",
                viewInsuranceDetailPage: "View Insurance Detail Page",
                viewPolicyPage: "View My Policy Page",
                ok: "Change Version",
                cancel: "Close Window",
              },
              modal: {
                title: "Do you want to change the version",
                description:
                  "Change version from {{from}} to version {{to}}. Changing the version will affect the policy details.",
                beforeChange:
                  "You can view version {{to}} information before actually changing.",
                viewInsuranceDetailPage: "View Insurance Detail Page",
                viewPolicyPage: "View My Policy Page",
              },
              policyInfo: "Additional policy information (can be edited)",
              paymentInfo: "Payment information",
              installments: "Payment installments",
              cutOffMethod: "Cut-off method",
              installment: "Payment installments",
              paymentMethods: "Payment methods",
              totalPremium: "Total insurance premium",
              alreadyPaid: "Premiums already paid",
              installmentsAlreadyPaid: "Number of installments already paid",
              baht: "{{amount}} thb",
              table: {
                installment: "installment",
                year: "Year",
                amount: "Amount due",
                status: "Status",
                dueDate: "Due date",
                paymentDate: "Payment date",
                paymentId: "Payment ID",
                agreementInstallmentStatus: {
                  PENDING: "Pending",
                  PAID: "Paid",
                  OVERDUE: "Overdue",
                },
              },
              paymentType: {
                INSTALLMENT: "Monthly",
              },
              InstallmentDetail: {
                home: "Home",
                title: "Insurance",
                installment: "installment {{number}}",
                insuranceInfo: "Insurance policy information",
                paymentInfo: "Payment information",
                back: "Back",
                policyName: "Policy name",
                type: "Type",
                insuranceCompany: "Insurance Company",
                insured: "Name of the insured",
                applicationNumber: "Application number",
                agreementInfo: {
                  installment: "installment",
                  year: "Year",
                  amount: "Amount due",
                  status: "Status",
                  dueDate: "Due date",
                  paymentDate: "Payment date",
                  paymentId: "Payment ID",
                  agreementInstallmentStatus: {
                    PENDING: "Pending",
                    PAID: "Paid",
                    OVERDUE: "Overdue",
                  },
                  baht: "{{amount}} thb",
                },
              },
              paymentTypeEnum: {
                [EnumPaymentScheduleMethod.INSTALLMENT]:
                  "Automatic billing cycle / Subscription",
                [EnumPaymentScheduleMethod.PAY_BY_SELF]: "Pay by self",
              },
              paymentMethod: {
                [EnumPaymentMethod.CREDIT_CARD]: "Credit Card",
                [EnumPaymentMethod.BANK_TRANSFER]: "Bank Transfer",
                [EnumPaymentMethod.QR_PROMPTPAY]: "QR Promptpay",
                [EnumPaymentMethod.MONTHLY_CREDIT_CARD]: "Credit Card",
              },
            },
          },
          overdueTransaction: {
            index: {
              title: "Overdue Transaction",
              home: "Home",
              filter: {
                title: "Filters",
                ownerNameOrPolicyNumber: "Policy Owner Name, Policy Number",
                insuranceCompany: "Insurance Company",
                contactStatus: "Contact Status",
                reset: "Reset",
                filter: "Filter",
              },
              table: {
                contacted: "Contacted",
                ownerName: "Policy Owner Name",
                company: "Company",
                policyNumber: "Policy Number",
                amount: "Amount",
                dueDate: "Due Date",
                overdueDays: "Overdue (Days)",
              },
              contactStatus: {
                all: "All",
                contacted: "Contacted",
                notContacted: "Not Contacted",
              },
              confirmModal: {
                title: "Update Contact Status",
                body:
                  "Update status of <b>{{name}}</b> - <b>Policy No. {{policyNumber}}</b> to <b>{{status}}</b>?",
                cancel: "Cancel",
                confirm: "Confirm",
              },
              detailModal: {
                title: "Transaction Detail",
                ownerName: "Policy Owner Name",
                company: "Company",
                planName: "Insurance Plan Name",
                type: "Type",
                amount: "Amount",
                dueDate: "Due Date",
                overdueDays: "Overdue",
                lapseRemainingDays: "Lapse In",
                days: "Days",
                phone: "Phone Number",
                email: "Email",
                currentAddress: "Current Address",
                registrationAddress: "Registration Address",
                workAddress: "Work Address",
                policiesTitle: "Policies",
                policiesSubtitle: "(All insurance plans in the package)",
                baht: "THB",
                viewDetail: "View Detail >",
                close: "Close",
                markContacted: "Mark as Contacted",
              },
              notificationSuccess: "Successful transaction",
            },
          },
          lead: {
            index: {
              title: "Insurance Search Log",
              home: "Home",
              export: "Export Report",
              reset: "Reset",
              filter: "Filter",
              name: "Insurance name",
              type: "Type",
              insuranceCompany: "Insurance company",
              start: "Date of request submission from",
              end: "Until the date",
              status: "Status",
              insurance: "Insurance",
              phoneNumber: "Contact number",
              info: "Info",
              sendDate: "Send date",
              coverage: "Coverage",
              contacted: "Contacted",
              Male: "Male",
              Female: "Female",
              all: "All",
              columnStatus: {
                all: "All",
                contacted: "Contacted",
                nonContacted: "Non Contacted",
              },
              phoneNumberOptions: {
                all: "Showing both with and without a phone number.",
                have: "with a phone number",
                no: "Without a phone number",
              },
              notificationSuccess: "successful transaction",
              adjustStatus: "Adjust item status",
              cancel: "Cancel",
              confirm: "Confirm",
              updateDescription: "Want to adjust the status of",
              to: "to",
              orNot: "or not",
              nonContacted: "Haven't contacted yet",
              ipAddress: "IP Address",
            },
            exportModal: {
              title: "Export Report",
              cancel: "Cancel",
              confirm: "Confirm",
              header: "Name the Purchase Interest Report",
              item: "items",
              description:
                "The output report will be filtered based on the data in the table page.",
              name: "Report name",
              notificationSuccess: "successful transaction",
            },
          },
          notificationManagement: {
            index: {
              home: "Home",
              title: "Notification Management",
              header: "Notification Management",
              type: "Type",
              searchPlaceholder: "Search title / detail",
              reset: "Reset",
              filter: "Filter",
              columns: {
                type: "Type",
                header: "Header",
                detail: "Detail",
                params: "params",
                notificationDate: "Scheduled Date",
                status: "Status",
              },
              historyButton: "Notification History",
              addButton: "Add Notification",
              typeOptions: {
                all: "All",
                promotion: "Promotion",
                campaign: "Campaign",
                notice: "Notice",
                insurance: "Insurance",
                paymentReminder: "Payment Reminder",
                paymentReminderRenewalSamePremium:
                  "Payment Reminder Renewal Same Premium",
                paymentReminderRenewalChangedPremium:
                  "Payment Reminder Renewal Changed Premium",
                overduePaymentReminder: "Overdue Payment Reminder",
                overduePaymentReminderRenewalSamePremium:
                  "Overdue Payment Reminder Renewal Same Premium",
                overduePaymentReminderRenewalChangedPremium:
                  "Overdue Payment Reminder Renewal Changed Premium",
                profileUpdateSuccess: "Profile Update Successful",
                profileUpdateFailure: "Profile Update Failed",
                policyStatusUpdate: "Policy Status Update",
                policyApproved: "Policy Approved",
                policyUnderReview: "Policy Under Review",
                requestPolicyCancellation: "Request Policy Cancellation",
                policyCanceled: "Policy Canceled",
                policyNotApproved: "Policy Not Approved",
                refundSuccessful: "Refund Successful",
                cancellationSuccessful: "Cancellation Successful",
                autoDeduction: "Auto Deduction",
              },
              statusOptions: {
                active: "Active",
                inactive: "Inactive",
              },
              tooltips: {
                noScheduledDate:
                  "Items created by the system will not display the notification date\n(Notify immediately when an Action occurs as defined by the system)",
                activeStatus: "This notification is active",
                inactiveStatus: "This notification is inactive",
                notificationDate:
                  "Items created by the system will not display the notification date (Notify immediately when an Action occurs as defined by the system)",
                status: "Notification usage status",
              },
              deleteNotification: "Delete Notification",
              deleteNotificationInfo: "Notification",
              cannotBeRestored: "will be deleted and cannot be restored",
              cancel: "Cancel",
              delete: "Delete",
              deleteNotificationSuccess: "Notification deleted successfully",
              duplicateNotification: "Duplicate Notification",
              duplicateNotificationInfo:
                "Do you want to duplicate the notification?",
              closeWindow: "Close this window",
              duplicate: "Duplicate",
              duplicateNotificationSuccess:
                "Notification duplicated successfully",
            },
            history: {
              home: "Home",
              title2: "Notification Management",
              title: "Notification History",
              header: "Notification History",
              back: "Back",
              type: "Type",
              channel: "Channel",
              startDate: "Start Date",
              endDate: "End Date",
              dateRangeError: "End date must be after start date",
              searchPlaceholder: "Search header / detail / recipient",
              reset: "Reset",
              filter: "Filter",
              columns: {
                type: "Type",
                header: "Header",
                detail: "Detail",
                receiver: "receiver",
                channel: "Channel",
                notificationDate: "Notification Date",
              },
              typeOptions: {
                all: "All",
                promotion: "Promotion",
                campaign: "Campaign",
                notice: "Notice",
                paymentReminder: "Payment Reminder",
                paymentReminderRenewalSamePremium:
                  "Payment Reminder Renewal Same Premium",
                paymentReminderRenewalChangedPremium:
                  "Payment Reminder Renewal Changed Premium",
                overduePaymentReminder: "Overdue Payment Reminder",
                overduePaymentReminderRenewalSamePremium:
                  "Overdue Payment Reminder Renewal Same Premium",
                overduePaymentReminderRenewalChangedPremium:
                  "Overdue Payment Reminder Renewal Changed Premium",
                profileUpdateSuccess: "Profile Update Successful",
                profileUpdateFailure: "Profile Update Failed",
                policyStatusUpdate: "Policy Status Update",
                policyApproved: "Policy Approved",
                policyUnderReview: "Policy Under Review",
                requestPolicyCancellation: "Request Policy Cancellation",
                policyCanceled: "Policy Canceled",
                policyNotApproved: "Policy Not Approved",
                refundSuccessful: "Refund Successful",
                cancellationSuccessful: "Cancellation Successful",
                autoDeduction: "Auto Deduction",
              },
              channelOptions: {
                all: "All",
                webNotification: "Front Store Notification",
                email: "Email",
                sms: "SMS",
              },
            },
            new: {
              home: "Home",
              title2: "Notification Management",
              title: "Add Notification",
              detail: "Detail",
              notificationInformation: "Notification Information",
              type: "Type",
              notificationDate: "Notification Date",
              action: "Action",
              actionType: "When clicking on the text",
              url: "URL",
              urlHelperText:
                "Enter the desired URL, e.g., https://www.flexfreelance/account/profile, to navigate to the profile page",
              selectActionOptions: {
                urlRedirect: "URL Redirect",
                openPopup: "Open Popup",
              },
              notificationChannels: "Notification Channels",
              notificationChannelsRequired: "Please select at least 1 channel",
              webNotification: "Front Store Notification",
              webNotificationDescription:
                "This message will be shown immediately on Front Store when Web Notification is enabled, and can be viewed later in the “Notifications” menu on Front Store.",
              email: "Email",
              emailDescription:
                "This message will be sent to each user's mailbox based on the email address specified in their profile.",
              sms: "SMS",
              smsDescription:
                "This message will be sent to each user's mobile inbox based on the phone number specified in their profile.",
              subject: "Subject",
              importantNotification: "Important Notification",
              importantNotificationTooltip:
                "Mark this notification as important on Front Store.",
              detailsPlaceholder: "Please enter details",
              cancel: "Cancel",
              create: "Create",
              notificationSuccess: "Notification created successfully",
              typeOptions: {
                promotion: "Promotion",
                campaign: "Campaign",
                notice: "Notice",
                paymentReminder: "Payment Reminder",
                paymentReminderRenewalSamePremium:
                  "Payment Reminder Renewal Same Premium",
                paymentReminderRenewalChangedPremium:
                  "Payment Reminder Renewal Changed Premium",
                overduePaymentReminder: "Overdue Payment Reminder",
                overduePaymentReminderRenewalSamePremium:
                  "Overdue Payment Reminder Renewal Same Premium",
                overduePaymentReminderRenewalChangedPremium:
                  "Overdue Payment Reminder Renewal Changed Premium",
                profileUpdateSuccess: "Profile Update Successful",
                profileUpdateFailure: "Profile Update Failed",
                policyStatusUpdate: "Policy Status Update",
                policyApproved: "Policy Approved",
                policyUnderReview: "Policy Under Review",
                requestPolicyCancellation: "Request Policy Cancellation",
                policyCanceled: "Policy Canceled",
                policyNotApproved: "Policy Not Approved",
                refundSuccessful: "Refund Successful",
                cancellationSuccessful: "Cancellation Successful",
                autoDeduction: "Auto Deduction",
              },
              required: "Field is required",
            },
            edit: {
              home: "Home",
              title2: "Notification Management",
              title: "Add Notification",
              detail: "Detail",
              isActive: "Active",
              inactive: "Inactive",
              notificationInformation: "Notification Information",
              type: "Type",
              notificationDate: "Notification Date",
              action: "Action",
              actionType: "When clicking on the text",
              url: "URL",
              urlHelperText:
                "Enter the desired URL, e.g., https://www.flexfreelance/account/profile, to navigate to the profile page",
              selectActionOptions: {
                urlRedirect: "URL Redirect",
                openPopup: "Open Popup",
              },
              notificationChannels: "Notification Channels",
              notificationChannelsRequired: "Please select at least 1 channel",
              webNotification: "Front Store Notification",
              webNotificationDescription:
                "This message will be shown immediately on Front Store when Web Notification is enabled, and can be viewed later in the “Notifications” menu on Front Store.",
              email: "Email",
              emailDescription:
                "This message will be sent to each user's mailbox based on the email address specified in their profile.",
              sms: "SMS",
              smsDescription:
                "This message will be sent to each user's mobile inbox based on the phone number specified in their profile.",
              subject: "Subject",
              importantNotification: "Important Notification",
              importantNotificationTooltip:
                "Mark this notification as important on Front Store.",
              detailsPlaceholder: "Please enter details",
              instructionDescription:
                "You can specify numeric values from the system that differ for each recipient in the message as follows:",
              instructionOrderNumber: "For policy number, enter",
              orderNumber: " {{ORDER_NUMBER}} ",
              instructionExample: "e.g., Policy number ",
              approved: "has been approved",
              cancel: "Cancel",
              update: "Update",
              notificationSuccess: "Notification created successfully",
              typeOptions: {
                promotion: "Promotion",
                campaign: "Campaign",
                notice: "Notice",
                paymentReminder: "Payment Reminder",
                paymentReminderRenewalSamePremium:
                  "Payment Reminder Renewal Same Premium",
                paymentReminderRenewalChangedPremium:
                  "Payment Reminder Renewal Changed Premium",
                overduePaymentReminder: "Overdue Payment Reminder",
                overduePaymentReminderRenewalSamePremium:
                  "Overdue Payment Reminder Renewal Same Premium",
                overduePaymentReminderRenewalChangedPremium:
                  "Overdue Payment Reminder Renewal Changed Premium",
                profileUpdateSuccess: "Profile Update Successful",
                profileUpdateFailure: "Profile Update Failed",
                policyStatusUpdate: "Policy Status Update",
                policyApproved: "Policy Approved",
                policyUnderReview: "Policy Under Review",
                requestPolicyCancellation: "Request Policy Cancellation",
                policyCanceled: "Policy Canceled",
                policyNotApproved: "Policy Not Approved",
                refundSuccessful: "Refund Successful",
                cancellationSuccessful: "Cancellation Successful",
                autoDeduction: "Auto Deduction",
              },
              required: "Field is required",
            },
            components: {
              templateDescription: {
                dynamicVariableDescription:
                  "System variables can be specified, which differ for each recipient, in the message and URL, as follows:",
                [NotificationTemplateType.PAYMENT_REMINDER]: {
                  parameterDescription:
                    "The above settings affect notifications by \n <hl>{{key}}</hl> will make the system send notifications X days before the due date",
                  policyId: "For policy number, use <hl>{{key}}</hl>",
                  dueDate: "For due date, use <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.PAYMENT_REMINDER_RENEWAL_SAME_PREMIUM]: {
                  parameterDescription:
                    "The above settings affect notifications by \n <hl>{{key}}</hl> will make the system send notifications X days before the due date",
                  policyId: "For policy number, use <hl>{{key}}</hl>",
                  dueDate: "For due date, use <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.OVERDUE_PAYMENT_REMINDER]: {
                  parameterDescription:
                    "The above settings affect notifications by \n <hl>{{key}}</hl> will make the system send notifications X days after overdue",
                  policyId: "For policy number, use <hl>{{key}}</hl>",
                  dueDate: "For due date, use <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.OVERDUE_PAYMENT_REMINDER_RENEWAL_SAME_PREMIUM]: {
                  parameterDescription:
                    "The above settings affect notifications by \n <hl>{{key}}</hl> will make the system send notifications X days after overdue",
                  policyId: "For policy number, use <hl>{{key}}</hl>",
                  dueDate: "For due date, use <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.PAYMENT_REMINDER_RENEWAL_CHANGED_PREMIUM]: {
                  parameterDescription:
                    "The above settings affect notifications by \n <hl>{{key}}</hl> will make the system send notifications X days before the due date",
                  policyId: "For policy number, use <hl>{{key}}</hl>",
                  dueDate: "For due date, use <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.OVERDUE_PAYMENT_REMINDER_RENEWAL_CHANGED_PREMIUM]: {
                  parameterDescription:
                    "The above settings affect notifications by \n <hl>{{key}}</hl> will make the system send notifications X days after overdue",
                  policyId: "For policy number, use <hl>{{key}}</hl>",
                  dueDate: "For due date, use <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.PROFILE_UPDATE_SUCCESS]: {
                  changeData:
                    "For the data type being edited, use <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.PROFILE_UPDATE_FAILURE]: {
                  changeData:
                    "For the data type being edited, use <hl>{{key}}</hl>",
                  reason: "For the reason for failure, use <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.POLICY_APPROVED]: {
                  requestID: "For the request ID, use <hl>{{key}}</hl>",
                  insuranceCompany:
                    "For the insurance company, use <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.POLICY_UNDER_REVIEW]: {
                  requestID: "For the request ID, use <hl>{{key}}</hl>",
                  insuranceCompany:
                    "For the insurance company, use <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.REQUEST_POLICY_CANCELLATION]: {
                  requestID: "For the request ID, use <hl>{{key}}</hl>",
                  insuranceCompany:
                    "For the insurance company, use <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.POLICY_CANCELED]: {
                  requestID: "For the request ID, use <hl>{{key}}</hl>",
                  insuranceCompany:
                    "For the insurance company, use <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.POLICY_NOT_APPROVED]: {
                  requestID: "For the request ID, use <hl>{{key}}</hl>",
                  insuranceCompany:
                    "For the insurance company, use <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.REFUND_SUCCESSFUL]: {
                  requestID: "For the request ID, use <hl>{{key}}</hl>",
                  insuranceCompany:
                    "For the insurance company, use <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.CANCELLATION_SUCCESSFUL]: {
                  requestID: "For the request ID, use <hl>{{key}}</hl>",
                  insuranceCompany:
                    "For the insurance company, use <hl>{{key}}</hl>",
                },
              },
            },
          },
          nameChangeRequest: {
            index: {
              home: "Home",
              title: "Name Change Request",
              header: "Name Change Request",
              searchPlaceholder: "Name-Surname, Email",
              reset: "Reset",
              filter: "Filter",
              columns: {
                fullName: "Name-Surname (new)",
                email: "Email",
                createdAt: "Request Date",
                updatedAt: "Approval Date",
                status: "Status",
              },
              status: {
                [NameChangeRequestStatus.NEW]: "Pending",
                [NameChangeRequestStatus.APPROVED]: "Approved",
                [NameChangeRequestStatus.SUCCESS]: "Approved",
                [NameChangeRequestStatus.REJECTED]: "Not Approved",
                [NameChangeRequestStatus.FAILED]: "Not Approved",
              },
              approveModal: {
                title: "Approve",
                confirmText:
                  "Change name from <b>{{oldName}}</b> to <b>{{newName}}</b>?",
              },
              rejectModal: {
                title: "Reject",
                confirmText:
                  "Specify the reason for rejecting the name change from <b>{{oldName}}</b> to <b>{{newName}}</b>",
                reasonLabel: "Reason",
                reasonOptions: {
                  unreadableOrExpiredId:
                    "Document photo is unclear / ID card expired",
                  mismatchedNameOnId:
                    "Name does not match the ID card document",
                  noNameChangeDocument:
                    "Missing name change document / marriage certificate",
                  missingSignatureOrWrongDocType: "Typo / invalid signature",
                  other: "Other (please provide additional details)",
                },
                reasonOtherLabel: "Additional Reason",
              },
              documentModal: {
                title: "Name Change Evidence",
                page: "{{current}} of {{total}}",
                noAttachment: "No attachment file",
                loadingPdf: "Loading...",
                pdfLoadError:
                  "Could not load this PDF. Please try again or open the file in a new tab.",
                pdfPageTitle: "{{name}}",
                attachmentGroup: {
                  nameChangeDocument: "Name Change Document",
                  idCardCopy: "ID Card Copy",
                },
              },
              cancel: "Cancel",
              approve: "Approve",
              approveDisabledTooltip:
                "You must view the last page of the document before approving",
              reject: "Reject",
              approveSuccess: "Name change approved successfully",
              rejectSuccess: "Name change rejected successfully",
              alreadyProcessedTitle: "Edit Failed",
              alreadyProcessedMessage:
                "Another user has already edited and saved this record.\n Please refresh the page to review the latest data before proceeding.",
              alreadyProcessedOk: "OK",
            },
          },
          user: {
            index: {
              title: "User Management",
              home: "Home",
              reset: "Reset",
              filter: "Filter",
              keyword:
                "Search for first name, last name / email / phone number",
              name: "First name, last name",
              email: "Email",
              phoneNumber: "Phone number",
              noOfPolicies: "Number of policies",
              createdAt: "Register date",
              viewTransaction: "View insurance policy",
              viewPayment: "View payment details",
            },
            detail: {
              userInfo: "User information",
              home: "Home",
              name: "User name",
              email: "Email",
              phoneNumber: "Phone number",
              noOfPolicies: "Number of policies",
              providerType: "Register method",
              createdAt: "Register date",
              back: "Back",
              viewTransaction: "View insurance policy",
              viewPayment: "View payment details",
              image: "Image",
            },
          },
          riderConfig: {
            title: "Rider Config",
            home: "Home",
            header: "Additional contract relationships",
            description1:
              "Used to set up the Web Application on the “Buy Insurance with Us” page.",
            description2:
              "By entering information about how each type of insurance is related to each other as an additional contract, for example, if you enter that IPD insurance is an additional contract for accident insurance",
            description3:
              "When the user selects IPD coverage, the system will automatically select accident insurance.",
            notification:
              "Editing this section will not retroactively affect previously created insurance plans.",
            example: "Example of a “Buy Insurance with Us” page",
            additionalContract: "Additional contract",
            notificationSuccess: "successful transaction",
            close: "Close",
            delete: "Delete",
            deleteTitle: "Delete additional contracts",
            deleteItem1: "Additional contract information",
            deleteItem2: "of",
            deleteItem3: "will be deleted and cannot be restored",
            noData: "No additional contract information",
            ManageRiderConfigModal: {
              title: "Select additional {{name}} contracts",
              description:
                "If IPD insurance is entered as an additional contract for accident insurance, when the user selects IPD coverage, the system will automatically select accident insurance.",
              insuranceType: "Insurance type",
              cancel: "Cancel",
              select: "Select",
              notificationSuccess: "successful transaction",
              errorTitle: "An error occurred.",
              close: "Close",
              loopDetected1: "The additional contract information for",
              loopDetected2: "is incorrect. Please check again.",
              errorDescription:
                "This is due to inconsistency between the main insurance and the additional contract. Please double-check the information in the additional contract to ensure it is correct.",
            },
          },
          broker: {
            index: {
              title: "Add/Remove Broker",
              home: "Home",
              add: "Add Broker",
              name: "Broker Name",
              status: "Status",
              columnStatus: {
                all: "All",
                active: "Active",
                inactive: "Inactive",
              },
              refId: "Ref ID",
              remark: "Remark",
              updatedAt: "Updated At",
              reset: "Reset",
              filter: "Filter",
              deleteBroker: "Delete Broker",
              brokerInfo: "Broker",
              cannotBeRestored: "data will be deleted and cannot be recovered.",
              close: "Close this window.",
              delete: "Delete",
              notificationSuccess: "successful transaction",
            },
            new: {
              title: "Add Broker",
              home: "Home",
              rootPath: "Broker Management",
              header: "Broker Info",
              active: "Active",
              name: "Broker Name",
              refId: "Ref ID",
              remark: "Remark",
              cancel: "Cancel",
              create: "Create",
              notificationSuccess: "successful transaction",
            },
            edit: {
              home: "Home",
              rootPath: "Broker Management",
              header: "Broker Info",
              active: "Active",
              name: "Broker Name",
              refId: "Ref ID",
              remark: "Remark",
              cancel: "Cancel",
              save: "Save",
              notificationSuccess: "successful transaction",
            },
          },
          order: {
            index: {
              home: "Home",
              title: "Order Management",
              export: "Export Report",
              form: {
                keyword: "Application number, Policyholder's name",
                insuranceCompany: "Insurance Company",
                type: "Type",
                status: "Order status",
                paymentStatus: "Payment status",
              },
              reset: "Reset",
              filter: "Filter",
              all: "All",
              table: {
                applicationNumber: "Application number",
                insured: "Name of the insured",
                company: "Company",
                type: "Type",
                amount: "Payment amount",
                status: "Order status",
                paymentStatus: "Payment status",
                updatedAt: "Updated at",
              },
              orderStatus: {
                all: "All",
                [EnumOrderStatus.PENDING_REVIEW]: "Waiting",
                REVIEWED: "Reviewed",
                [EnumOrderStatus.DRAFT]: "Draft",
                [EnumOrderStatus.APPROVED]: "Reviewed",
                [EnumOrderStatus.REJECTED]: "Reviewed",
                failedTooltip:
                  'Orders created from selecting an insurance plan (transaction not yet completed) will not show payment information and cannot have their status edited. The system will automatically change the status to "Pending Review" when the transaction is completed.',
              },
              paymentStatus: {
                all: "All",
                [EnumPaymentStatus.PENDING_PAYMENT]: "Waiting",
                [EnumPaymentStatus.SUCCESS]: "Succeed",
                [EnumPaymentStatus.CANCELLED]: "Canceled",
              },
              EditStatusModal: {
                title: "Update order status",
                state: "Order Status",
                of: "of",
                affectedTitle:
                  "Changing the order status will affect the following linked policies:",
                status: {
                  WAITING: "Waiting",
                  APPROVED: "Approved",
                  REJECTED: "Rejected",
                  FAILED: "Failed",
                },
                cancel: "Cancel",
                confirm: "Confirm",
                success: "Successful transaction",
              },
              notificationSuccess: "successful transaction",
              Male: "Male",
              Female: "Female",
              relationValue: {
                father: "Father",
                mother: "Mother",
                child: "Child",
                spouse: "Spouse",
                life_partner: "Life Partner",
              },
            },
            detail: {
              home: "Home",
              root: "Order Management",
              orderInfo: "Order information",
              policyInfo: "Insurance policy information",
              policyDescription: "All insurance plans included in the package",
              kycResult: "KYC results",
              back: "Back",
              applicationNumber: "Application number",
              insured: "Name of the insured",
              company: "Company",
              type: "Type",
              package: "Package name",
              netPayment: "Net payment",
              orderStatus: "Order status",
              paymentStatus: "Payment status",
              createdAt: "Created at",
              updatedAt: "Updated at",
              viewDetail: "View detail",
              baht: "{{amount}} thb",
              customPackage: "Custom Package",
              failedTooltip:
                'Orders created from selecting an insurance plan (transaction not yet completed) will not show payment information and cannot have their status edited. The system will automatically change the status to "Pending Review" when the transaction is completed.',
              kycStatus: {
                passed: "Passed",
                pending: "Pending",
              },
              PolicyDetailModal: {
                title: "Order details",
                viewPolicyDetail: "View policy details",
                close: "Close",
                healthQuestion: "Health question",
                policyholder: "Policyholder",
                benefitMoney: "Benefit money",
                beneficiaries: "Beneficiaries",
                fullname: "Name-Surname",
                relation: "Relation",
                percent: "Percentage of benefits",
                benefitMoneyQuestion:
                  "If there are insurance policy benefits in the form of dividends/policy refunds.",
                accountName: "Account holder's name",
                bankAccount: "Bank account number",
                bank: "Bank",
                branch: "Branch",
                gender: "Gender",
                policyHolderQuestion:
                  "Do you wish to claim an exemption from income tax?",
                fullnameEn: "Name-Surname (EN)",
                birthDate: "Date of Birth (AD)",
                age: "Age",
                nationality: "Nationality",
                status: "Status",
                email: "Email",
                phoneNumber: "Phone number",
                occupation: "Occupation",
                workplaceName: "Workplace Name",
                annualIncome: "Annual income (Baht)",
                currentAddress: "Current address",
                registeredAddress: "Registered address",
                workAddress: "Work address",
                excepTaxYes: "Yes",
                excepTaxNo: "No",
                ageUnit: "years",
                relationValue: {
                  father: "Father",
                  mother: "Mother",
                  child: "Child",
                  spouse: "Spouse",
                  life_partner: "Life Partner",
                },
              },
              KycResultModal: {
                title: "Order details",
                close: "Close",
                question: "Question",
                nationalIdNumber: "National ID number",
                backIdCardCode: "Code on the back of the ID card",
              },
              status: {
                [EnumOrderStatus.PENDING_REVIEW]: "Waiting",
                [EnumOrderStatus.DRAFT]: "Draft",
                [EnumOrderStatus.APPROVED]: "Reviewed",
                [EnumOrderStatus.REJECTED]: "Reviewed",
              },
              paymentStatusText: {
                [EnumPaymentStatus.PENDING_PAYMENT]: "Waiting",
                [EnumPaymentStatus.SUCCESS]: "Succeed",
                [EnumPaymentStatus.CANCELLED]: "Canceled",
              },
            },
          },
        },
        auth: {
          ResetPassword: {
            forgotPassword: "Forgot Password",
            inputEmail: "Input email to create password for login",
            send: "send",
            link1: "URL link has already send to email \n{{email}}\n",
            link2: "Please click below link to create password for login",
          },
        },
      },
      components: {
        common: {
          languagesDropdown: {
            label: "language",
            lang: "English",
          },
          PopMenu: {
            logout: "Logout",
            logoutInfo1: "Do you want to logout? If you want, please press",
            logoutInfo2: "to logout.",
            confirmLogout: "Confirm",
            cancel: "Cancel",
            profile: "Profile",
            avatar: "AD",
          },
          JsonEditorReact: {
            modalTitle: "Invalid Data Type",
            modalDescription: "Please check the data types of the parameters:",
            okButtonLabel: "OK",
            or: "or",
            validationError:
              '"{{key}}" must be {{expectedTypes}} but received {{actualType}}',
            typeNames: {
              string: "Text",
              number: "Number (decimal)",
              integer: "Integer number",
              boolean: "Boolean",
              array: "Array",
              object: "Object",
            },
            rangeErrorTitle: "Value out of allowed range",
            rangeErrorMin: '"{{key}}" must be at least {{min}}',
            rangeErrorMax: '"{{key}}" must not exceed {{max}}',
            keyMismatchError:
              "Parameter name cannot be changed. Expected: {{keys}}",
          },
          MaterialIcon: {
            notFoundIcon: "Icon Not Found",
          },
          UploadAvatar: {
            avatar: "AD",
          },
          InfoCard: {
            viewDetail: "View detail",
            baht: "{{amount}} thb",
            broker: "Broker:",
          },
        },
        advance: {
          AddressList: {
            total: "total {{amount}}",
            addressNo: "Address {{index}}",
          },
          FileUploadList: {
            total: "total {{amount}}",
          },
          SingleFileUpload: {
            uploadFile: "Upload File",
            invalidFileExtension: "Only {{extensions}} files are supported",
          },
          Editor: {
            enterText: "Enter text here...",
          },
          JsonForms: {
            noData: "No data",
            noSelection: "No selection",
          },
        },
        SideBar: {
          appName: "My Benefit",
        },
        Table: {
          noData: "No Data",
          noDataOnFilter:
            "No search results were found. Please check the values in the filter again.",
          noInsuranceData: "No insurance data",
        },
        FilterTableWithQueryParams: {
          confirm: "Filter",
          reset: "Reset",
        },
      },
      routes: {
        menu: {
          customerService: "Customer Service",
          appScreenDisplay: "App Screen Display",
          notification: "Notification",
          adminManagement: "Admin Management",
          adminMenu: "Add/Remove Admin",
          roleMenu: "Set Permissions",
          systemAndData: "System & Data Management",
          insuranceMenu: "Insurance",
          settingMenu: "Setting",
          menu: "menu",
          insurance: "Manage Package & Weight",
          enrollment: "Enable/Disable Insurance & Package",
          report: "Export Report",
          marketplaceReport: "Export Marketplace Report",
          insuranceCompany: "Add/Remove Insurance Company",
          occupation: "Add/Remove Occupation",
          dynamicConfig: "Dynamic Config",
          workspace: "Add/Remove Workspace",
          insurancePlan: "Add/Remove Insurance Plan",
          paymentTransaction: "Payment Summary",
          insuranceTransaction: "Policy Status",
          overdueTransaction: "Overdue Transaction",
          lead: "Insurance Search Log",
          notificationManagement: "Notification Management",
          user: "User Management",
          riderConfig: "Rider Config",
          frontStoreManagement: "Front Store Management",
          broker: "Add/Remove Broker",
          nameChangeRequest: "Name Change Request",
          productManagement: "Insurance Management",
          order: "Order Management",
        },
        Routes: {
          expireTimeAlertTitle: "Session Expired",
          expireTimeAlertChildren:
            "Please log in again as there has been no system activity for {{timeout}} minutes.",
          expireTimeAlertOkButtonLabel: "Log in again",
        },
      },
      yup: {
        error: {
          required: "Field is required",
          requiredTh: "Field is required (TH)",
          requiredEn: "Field is required (EN)",
          invalidEmailSyntax: "Invalid email syntax",
          typeNumber: "Must be a number",
          GtZero: "Must be a number greater than zero",
          GteZero: "Must be a number greater than or equal zero",
          GteOne: "Must be a number greater than or equal one",
          insuranceNameThDuplicate:
            "The insurance name (TH) is the same as the one in the system",
          insuranceNameEnDuplicate:
            "The insurance name (EN) is the same as the one in the system",
          packageNameThDuplicate:
            "The package name (TH) is the same as the one in the system",
          packageNameEnDuplicate:
            "The package name (EN) is the same as the one in the system",
          invalidEmailFormat: "Email format is invalid",
          invalidPhoneNumberFormat: "Phone number format is invalid",
          nameDuplicate:
            "It must not be a duplicate of something already in the system.",
          scheduledAtPast: "Cannot select a past date and time",
          maxDate: "Date must not be after the maximum allowed date",
          minDate: "Date must not be before the minimum allowed date",
          maxLength200: "Must be at most 200 characters",
          enRequired: "English is required",
          thRequired: "Thai is required",
        },
      },
      error: {
        notCurrentVersion:
          "Cannot save edits to this version because\na customer has successfully purchased insurance while editing. Please return to the table\nand click edit again. The system will automatically create a new version.",
        required: "Field is required",
        saveError: "This insurance form has been published",
        accept: "Ok",
        saveErrorChildren:
          "This registration has already been published. Please press the (OK) button to refresh and try again.",
        notEmptyAtLeastOne: "Please select at least one type of insurance",
        duplicate: "It must not be a duplicate of an existing item.",
        phoneNumberInvalid: "Invalid phone number format.",
        enRequired: "English is required",
        thRequired: "Thai is required",
        close: "Close this window",
        masterInsurancePlanPublishedValidationFailed: {
          detail: "Insurance Plan Details",
          customPackage: "Coverage Packages",
          premiums: "Premiums",
          conditions: "Conditions",
          result: "Inspection results",
          notReadyToPublish:
            "Version {{versionName}} is not yet available for release.",
          errorMessages:
            "Some information is incomplete. Please check the following data",
          close: "Close",
        },
        dependencyLoopDetected: {
          errorTitle: "An error occurred",
          close: "Close",
          loopDetected1: "The sales criteria information for",
          loopDetected2: "is incorrect. Please check again.",
          errorDescription:
            "This is due to an inconsistency between the main insurance policy and the supplementary contract. Please double-check the information for accuracy.",
        },
      },
      modal: {
        delete: {
          title: "Confirm Delete",
          confirm: "Delete",
          close: "close",
        },
        close: "close",
      },
      validateMasterInsurancePlanDependenciesErrorModal: {
        saveUnsuccess: "Data saving failed",
        invalidDependentContent:
          "Because there is no primary insurance coverage for the following insurance policies",
        accept: "OK",
        rider: "Additional contract",
        dependent:
          "At least one additional primary insurance policy must be added",
      },
    },
  },
};

export default en;
